(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWcow_atlas_", frames: [[1828,922,112,348],[602,960,112,348],[1888,528,132,392],[0,576,132,392],[806,576,122,382],[682,576,122,382],[930,576,120,374],[1052,576,120,374],[552,576,128,366],[422,576,128,366],[278,576,142,356],[134,576,142,356],[368,944,232,172],[1604,902,222,192],[1174,892,218,202],[1174,688,220,202],[134,934,232,180],[930,952,232,170],[1596,528,144,372],[1742,528,144,372],[1440,0,142,422],[1584,0,142,422],[716,960,130,176],[0,970,130,176],[912,312,226,262],[1140,312,226,262],[1368,424,226,262],[456,312,226,262],[684,312,226,262],[1728,0,226,262],[1728,264,226,262],[0,312,226,262],[228,312,226,262],[0,0,478,310],[480,0,478,310],[960,0,478,310],[1394,902,208,208],[1396,688,176,176]]}
];


// symbols:



(lib.CowFrontLegBack0001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg0001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg0002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0020001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0020002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0030001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0030002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0040001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0040002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0050001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CowFrontLeg_0050002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CowHead_001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CowHead_003 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CowHead_005 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CowHead_006 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CowHead_moo = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CowHead_moo_001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CowHindLegBack0001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CowHindLegBack0002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CowHindLeg0001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CowHindLeg0002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CowNeck0001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CowNeck0002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0001 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0176 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0178 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0180 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0182 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0184 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0186 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0188 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.CowTail0190 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.CowTorso0002 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.CowTorso0003 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.CowTorso0004 = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWcow_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAdAoIAKANAgEAwIAAAOAgrArIALgNAgmgrIANAPAg9AAIAYgBAAgghIAJgMAACg9IAAAUAAtACIARAA");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.cow_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AKOAOQAugYgJgjQgIgigkh7Ii1AAQiUgJiBgCQiCgChKAAImpgCQjZAWgiBcQAAACgBACQARBUBOBYQAuA1AzAgQA2AhAvAAQAbAAAagFQAggHA7gFQA8gEBnADQBmADByAWQBzAUBYgBQBagBBghYQBghZAtgZg");
	this.shape.setTransform(72.8,36.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cow_tummyGlow, new cjs.Rectangle(0.5,11.7,144.5,49.5), null);


(lib.cow_neckGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("ACrk1QgXgKhHAHQguBkhsAvQgCAIgBAUQgHC/h+CAQgKAJgIAIQAWAUAcAUQBrBNBHAAQB8AABPj1QAbhPAEgxQADglgFg3QgGg2gMgvQgMgvgcgMg");
	this.shape.setTransform(28.1,32.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cow_neckGlow, new cjs.Rectangle(1.9,-2,52.4,69.1), null);


(lib.cow_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AGmm9QgLBRAIBQQAHBQBHBiQBHBigBD+QgLAYgJAVQgGAGgIAJQgBABgBACQgYgEgUAWQgLANgNAVQgeAuACAKQACAFAIADQAHAEAFAAQAMAAANgKQgCAEgDANQgBACgBABQAYAIATAAQAmAAAngOQAjgMAAgIQAAgRgEgPQALgBAJgWQAJgWgDgMQgEgVAEgeQAGgrAAgQQAMg+ARgWIAAAAQARApAUA6QAeBZgfA1QgEAGgCAFQgdgFgXAZQgNAPgPAYQgiAzADAMQACAGAJAEQAHADAGAAQAOAAAOgKQgCAEgDAPQgBACgBACQAbAIAVAAQArAAAsgPQAogPAAgJQAAgZgJgVQAHgPAEglQAFg0gHgoQgOhMASgPQARgPAMheQAMhfAAgRQAAgTgIgTQgMgVgHgMQgbgzAAhIQANhIAOhLQAOhOgHhAQgHhHifAIQg5AFhEAGQh/ALgLBSgAkojNIAAAAQgQAmgWApQgTAjggA4QgYAqAAASQAAAQAKAzQAJA0AAACQAAABAAANQgBAQgGANQgGAPgKAKQgCAOgHAoQgJA4AAAHQAAAEAMAiQANAjAAAGIABAFQAAAFgDAEQgHAJgUAEQAdAeAAAtQAAAJgoAPQgsAPgrAAQgVAAgbgIQABgCABgCQADgPACgEQgOAKgOAAQgGAAgHgDQgJgEgCgGQgDgMAigzQAPgYANgPQAVgXAaACQAEgKAFgLQAQgpAAgyQAAgdgLgeQgVgLgNgXQgQgbAAgaQAAgOAHgLQAGgMAAgGQAAhpgWhTQgIgggahCQBtiZCNA5QA8AQgHBEIAAAAIAAAAApXjBQgFAfgGAlQAAABAAAAQAAABAAABQgDAQgDASQAAACAAABQgCAIgBAIQgBABAAACQgnDfgOAoIAAB6QgEAQAJA3QgBAcgVALQACALAAALQAAAIghAMQgkANgkAAQgSAAgVgIQAAgBABgCQADgMABgDQgLAIgMAAQgFAAgGgDQgHgDgCgFQgCgJAcgrQAMgUALgMQATgUAYAEQABgjAIgUQAJgXAAgqQAAgbgQgXQgQgWAAgkQAAgVAIgQQAIgRAAg5QAAg3hDhlQhDhkBfgvQBfguAYAIQBRgNAQCRg");
	this.shape.setTransform(-36.7,104.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cow_legGlow, new cjs.Rectangle(-129.4,-2.6,182.9,165), null);


(lib.cow_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AE5CHQA5g+A2haQA1hcAbgnQATgcgBAAIkfACQiWgiiCgHQiEgGhMAAIkKAAQgGA+AJCnQAICoBpAmQAPAFG/ADQBGABBAgNQA/gMA5g/g");
	this.shape.setTransform(65.7,23.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cow_backGlow, new cjs.Rectangle(10.5,-1.8,110.5,50.5), null);


(lib.bluelgowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AE5CHQA5g+A2haQA1hcAbgnQATgcgBAAIkfACQiWgiiCgHQiEgGhMAAIkKAAQgGA+AJCnQAICoBpAmQAPAFG/ADQBGABBAgNQA/gMA5g/g");
	this.shape.setTransform(65.7,23.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluelgowback, new cjs.Rectangle(10.5,-1.8,110.5,50.5), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AKOAOQAugYgJgjQgIgigkh7Ii1AAQiUgJiBgCQiCgChKAAImpgCQjZAWgiBcQAAACgBACQARBUBOBYQAuA1AzAgQA2AhAvAAQAbAAAagFQAggHA7gFQA8gEBnADQBmADByAWQBzAUBYgBQBagBBghYQBghZAtgZg");
	this.shape.setTransform(72.8,36.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(0.5,11.7,144.5,49.5), null);


(lib.blueglowneck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("ACrk1QgXgKhHAHQguBkhsAvQgCAIgBAUQgHC/h+CAQgKAJgIAIQAWAUAcAUQBrBNBHAAQB8AABPj1QAbhPAEgxQADglgFg3QgGg2gMgvQgMgvgcgMg");
	this.shape.setTransform(28.1,32.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowneck, new cjs.Rectangle(1.9,-2,52.4,69.1), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AGmm9QgLBRAIBQQAHBQBHBiQBHBigBD+QgLAYgJAVQgGAGgIAJQgBABgBACQgYgEgUAWQgLANgNAVQgeAuACAKQACAFAIADQAHAEAFAAQAMAAANgKQgCAEgDANQgBACgBABQAYAIATAAQAmAAAngOQAjgMAAgIQAAgRgEgPQALgBAJgWQAJgWgDgMQgEgVAEgeQAGgrAAgQQAMg+ARgWIAAAAQARApAUA6QAeBZgfA1QgEAGgCAFQgdgFgXAZQgNAPgPAYQgiAzADAMQACAGAJAEQAHADAGAAQAOAAAOgKQgCAEgDAPQgBACgBACQAbAIAVAAQArAAAsgPQAogPAAgJQAAgZgJgVQAHgPAEglQAFg0gHgoQgOhMASgPQARgPAMheQAMhfAAgRQAAgTgIgTQgMgVgHgMQgbgzAAhIQANhIAOhLQAOhOgHhAQgHhHifAIQg5AFhEAGQh/ALgLBSgAkojNIAAAAQgQAmgWApQgTAjggA4QgYAqAAASQAAAQAKAzQAJA0AAACQAAABAAANQgBAQgGANQgGAPgKAKQgCAOgHAoQgJA4AAAHQAAAEAMAiQANAjAAAGIABAFQAAAFgDAEQgHAJgUAEQAdAeAAAtQAAAJgoAPQgsAPgrAAQgVAAgbgIQABgCABgCQADgPACgEQgOAKgOAAQgGAAgHgDQgJgEgCgGQgDgMAigzQAPgYANgPQAVgXAaACQAEgKAFgLQAQgpAAgyQAAgdgLgeQgVgLgNgXQgQgbAAgaQAAgOAHgLQAGgMAAgGQAAhpgWhTQgIgggahCQBtiZCNA5QA8AQgHBEIAAAAIAAAAApXjBQgFAfgGAlQAAABAAAAQAAABAAABQgDAQgDASQAAACAAABQgCAIgBAIQgBABAAACQgnDfgOAoIAAB6QgEAQAJA3QgBAcgVALQACALAAALQAAAIghAMQgkANgkAAQgSAAgVgIQAAgBABgCQADgMABgDQgLAIgMAAQgFAAgGgDQgHgDgCgFQgCgJAcgrQAMgUALgMQATgUAYAEQABgjAIgUQAJgXAAgqQAAgbgQgXQgQgWAAgkQAAgVAIgQQAIgRAAg5QAAg3hDhlQhDhkBfgvQBfguAYAIQBRgNAQCRg");
	this.shape.setTransform(-36.7,104.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-129.4,-2.6,182.9,165), null);


(lib.FrontLegSpots_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 7
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00004A").s().p("AgaBPQgDgRAAgrQAAgVgKgjQgKgiAAgLQAAhQAxBSQAyBQAAAoQAAAWgJAZQgNAkgYAAQgXAAgHgsg");
	this.shape.setTransform(-9.6,42.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 8
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#00004A").s().p("AgwAgIgBgQQAAgRAQgSQAOgQATgHQAygSAAA0QAAATgMAPQgRAWgiAAQgcAAgHgQg");
	this.shape_1.setTransform(-14.4,-12.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer 9
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#00004A").s().p("AgmAbIgBgSQAAgrAngHQAQgDAMAIQAMAIAAARQAAARgJAPQgNAWgbAAQgXAAgGgQg");
	this.shape_2.setTransform(-1.4,61.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 10
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#00004A").s().p("Ag6AzIgCgOQAAgYATgbQARgaAYgOQAYgPAQAKQATALAAApIACAOQABAOgEAKQgOAhhAAAQgeAAgIgNg");
	this.shape_3.setTransform(2.7,6.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

	// Layer 11
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#00004A").s().p("AgpDWQgGgJgFgQIgJgWQgIgNgZgHQgZgHgHgPQgEgGABgOQABgRgBgGQgIgogUg2QgOgkAAgpQgDgrACgMQACgMAcg6QAVguAuAgQAKAIAYAWQAUASAIAEQAPAEALAZQAKAXAbAAQA5gCAaASQAOAJAIATQADALAIA1QAHAxAAAKQAAB2hIAyQgXAQgbAHIgXAFIABAEQgygBgUgcg");
	this.shape_4.setTransform(2.1,-41.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(1));

}).prototype = getMCSymbolPrototype(lib.FrontLegSpots_001, new cjs.Rectangle(-19.4,-65.4,38.8,130.9), null);


(lib.CowTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{loopback:171});

	// Layer 2
	this.instance = new lib.CowTail0001();
	this.instance.parent = this;
	this.instance.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_1 = new lib.CowTail0176();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_2 = new lib.CowTail0178();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_3 = new lib.CowTail0180();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_4 = new lib.CowTail0182();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_5 = new lib.CowTail0184();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_6 = new lib.CowTail0186();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_7 = new lib.CowTail0188();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-87.8,-63.2,0.5,0.5);

	this.instance_8 = new lib.CowTail0190();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-87.8,-63.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},175).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance}]},2).wait(2));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00004A").s().p("AgqC2QgTggAAgHIAIgxQgNgDgGgLQgFgIAAgIQAAgUAHgNQgDgFAAgGQAAgdAQgXQAAgjAWgtQARgnAXgeIAFgGQAcggATABQAIAAAFAIQAIALAAAcQAABTgYBTQgYBTAABfQAAATgDAIQgGATgWAAQgSAAgXglg");
	this.shape.setTransform(-8,39.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Ah1GTIAAgeQAAhvARheQAQhYApiAQAkhyAXhgIAMg0QAIghAIgUQAQgpAdgIQAdgJAAAsQAAA9guCbIg6C/QgLA1gZC7QgMBKgPApQgFgIgIAAQgTgBgcAgIgFAGQgCgFgBgGg");
	this.shape_1.setTransform(4,-20);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#00004A").s().p("AgIC5IgPgmQgOALgLABQgJABgDgFQgJgMAAgQQgFAAgDgEQgOgTAEghQgPgWgBg0QgBguAKguIACgJQALg1ATgWIABgBQAFgFAEgCIAAAAQAXAIALAIIABABQAKAPAIARIABABIAAAAQASAjALAtIADAPQAPBPAtA7QAJAMABAJQACAUgVAaQgSAWgnADIgSAAQgPAAgDgDg");
	this.shape_2.setTransform(-27.3,30.6);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AjKGDQgJgVgLgMQgSgQgQAAIAAAAQALhhA3iZQA3iZCZiVQCbiWAZgSQAagSARAqQAJATAHAeQmWErg0GOIAAAAIgBgBg");
	this.shape_3.setTransform(-6.8,-22);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#00004A").s().p("AgEC7IgWgnQgQAMgOABQgMAAgEgEQgNgNAAgPQgHgBgDgDQgTgTAEgiQgVgVgDg0QgDguAJgvIACgJQANg0AWgXIACgBQAJgIAKgBQAQgCASASIAEAEQArAtAXBDIAEAPQAYBPA8A8QAMAMABAIQAEAUgaAbQgWAVgyADIgWABQgUAAgDgDg");
	this.shape_4.setTransform(-44.1,9.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AkjELQgSgSgQACQgJABgKAIQgDhqB5h7QB5h7DEhUQDEhVAcgHQAegJAAAsQAAATgFAdQn7B5h4FPIgEgEg");
	this.shape_5.setTransform(-18.7,-34.4);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#00004A").s().p("Ag8BoQgEgBgEgGQgNAIgSgFQgGgCgFgKQgGgNACgTIgtAAQgGgBgTgmQgWgsAHgdQAKgkAUgHQAHgDARAEQBRAWBRgTIAOgDQA9gMA2AKIARAEIAFABQAOAEAHAGQAHAFADAHQACAEAAAGIgBALIAAABIgFAPQgMAZgeAbIgHAGQgkAggpAUQgvAYgdgIQgUAPgTAAQgHAAgHgBg");
	this.shape_6.setTransform(-65.6,10.1);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AkuE7QgDgHgGgFQCWhNB3h4QB2h3BZiXQBZiXAdgIQAdgJAAAsQAAATgEAeQlfIqkAALQgBgGgCgFg");
	this.shape_7.setTransform(-15.4,-28.9);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#00004A").s().p("AhUB7QgGgBgEgJQgFgMABgUIgmAJQgFAAgQgiQgUgpAHgeQAIgmARgKQAHgEAOABQBGAHBEgiIANgGQA0gWAuAAIAPAAIAEAAQAMACAGAEQAGAEADAGIACAKIgBALIAAACIgFAPQgKAbgaAiIgFAGQgfAmgkAdQgoAggZgDQgXAagWgCQgEgBgDgEQgKAIgMAAIgEAAg");
	this.shape_8.setTransform(-54,24.4);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AkCFyQgDgHgGgDQCBhpBmiOQBliNBNinQBMinAYgNQAagOAAAsQAAATgEAeQktJqjbA6IgCgKg");
	this.shape_9.setTransform(-11,-23.2);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#00004A").s().p("Ag4CCQgKgKgFgTIgqAPQgGABgegdQgkgjgDgeQgDglARgMQAGgGAQgBQBVgHBFgtIANgIQA2gfA1gJIARgCIAGgBQANAAAKACQAIADAFAGQADADADAGIACAKIABABIgBAQQgDAcgSAlIgFAHQgXApggAhQglAmgeADQgTAcgaACQgEABgGgEQgJALgSABIgBAAQgGAAgIgHg");
	this.shape_10.setTransform(-41.7,32.4);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("Ai1GWQgDgFgEgEQgFgFgHgDQBWiMBFibQBDiaA0iiQA0ihAYgRQAZgSAOApQAHATAGAdQkJLghxAAIgFgBg");
	this.shape_11.setTransform(-4.8,-19.9);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#00004A").s().p("AgCC2QgagigCgFQgBgfgDgSQgMgEgKgKIgJgQQgDgVADgMQgDgGgCgGQgGgdALgXQgGgiANguQALgnASgdIADgGQAWggARAAQAJABAGAIQAKAKAGAdQAQBSgFBUQgFBTAUBfQAEATgCAIQgCASgXACQgRgBggglg");
	this.shape_12.setTransform(1.6,39.5);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AhQGSIgFgeQgThvAGhdQAHhXAniAQAghyAYhgIAJg1QAHgfAGgVQANgpAbgIQAcgJAGAsQAFA+guCaIg5C+QgNA2gBC6QAABJgFApQgFgIgJAAQgSAAgWAgIgEAGIgFgMg");
	this.shape_13.setTransform(6.2,-20);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#00004A").s().p("AAIC9QgTgQgJgEIgQgtQgPgNgGgJIgEgbQgGgPAAgMQgEgHgBgGQgEgbAKgSQgFgZAIghQAIgkARgbQABgNAIgRQAMgUAMgLQAEgEADgBIAGgGIADgCQAHgBAEAEQAQgEALAUQANA3gBA6QgBA8ANBIQADAogJAhQgKAogPAhIgFABQgLAAgSgRg");
	this.shape_14.setTransform(-1.6,39.5);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AhdF7QgMhUAEg+QAFhfAfh2QAbhoAehrQAPg8AKgtIANg0QALgmAVgNQAYgTANAaQANAngeB1QgRBMgkB8QgSA+gLCgQgEBDgLBaQgIATgLANQgLgCgOAOIgGAHQgDAAgFAEIgKAKIgKgdg");
	this.shape_15.setTransform(5.1,-19.7);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#00004A").s().p("AARDHQgNACgOgCQgNgKgQgfQgRgXgDgIIACgmQgJgJgDgLQgFgHAAgIQgCgXAIgQQgEgPAEgSQAEghARgZQAAgYAPggQATgkAVgUQAFgCADABQAWgSAPAKQALAcABAhQAEAjAHAzQABA8gRA6QgQA+gIBAQgEAIgGAAQgEAAgFgDg");
	this.shape_16.setTransform(-4.8,39);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#FFFFFF").s().p("AhnGFQgGg4ACggQAChnAYhqQAWhfAjh2QAZhXAShHIAMg0QAJgjAPgQQAUgfAVAKQAVAOgPBRQgJBEgpCMQgVBIgWCHIgaDGQgKAugNAbQgJgFgNALQgNAAgTAXQgIgNgBgFg");
	this.shape_17.setTransform(4.4,-19.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_3},{t:this.shape_2}]},175).to({state:[{t:this.shape_5},{t:this.shape_4}]},2).to({state:[{t:this.shape_7},{t:this.shape_6}]},2).to({state:[{t:this.shape_9},{t:this.shape_8}]},2).to({state:[{t:this.shape_11},{t:this.shape_10}]},2).to({state:[{t:this.shape_13},{t:this.shape_12}]},2).to({state:[{t:this.shape_15},{t:this.shape_14}]},2).to({state:[{t:this.shape_17},{t:this.shape_16}]},2).to({state:[{t:this.shape_1},{t:this.shape}]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87.8,-63.2,113,131);


(lib.CowNeckSpots = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00004A").s().p("ABsEzIgEgWQAAgcAqAEQAqAFAAAbQAAAogoAAQgdAAgLgagAA/D0QhPgCgqhBQgKgRgIgVQglgPgNgOQgJgLAAglQAAgdATgZQgPgzAAgTQAAgEAIgRQAKgWANgRQArg1A7APQA+gSAYAlQAMASABAgQARARAAAlQAAAiAMAMQALAOAAASIAAAXQgCAPgLADQAkA+AAAEIAAAGQAEAJAAAMQAAASgFAPQgIAZgTAAIgIgBQgSAVgYAAQgKAAgNgJgAi5jMQgEgLACgLQAAgRANgNQAMgMAPgCQAogGAAA1QAAAVgBADQgFARgaAAQglAAgJgWgAg7kIQgEgFAAgTQAAgQATgNQARgMAYgCQA7gHAAAuQAAARgHALQgLASgcAAQg2AAgPgSg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowNeckSpots, new cjs.Rectangle(-18.8,-33.3,37.7,66.7), null);


(lib.CowHoof = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AhXBPQgygSAAgLQAAg/AugoQAhgdA0gNQAmgKAgAiQARASASAeQArBAgEAPQgCAHgMAFQgJAEgHAAQgSAAgSgNIAHAYIACAEQghAMgbAAQg1AAg3gUg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHoof, new cjs.Rectangle(-13.8,-9.8,27.7,19.7), null);


(lib.CowHindLegClean = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,final_loop:1});

	// Layer 4
	this.instance = new lib.CowHindLeg0002();
	this.instance.parent = this;
	this.instance.setTransform(-28.5,-95.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.8,-95.7,77.3,211);


(lib.CowHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:220,"final":221,"final_loop":222});

	// Layer 4
	this.instance = new lib.CowHindLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-30.9,-87.9,0.5,0.5);

	this.instance_1 = new lib.CowHindLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-30.9,-87.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},217).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-59.5,-88,100.6,186.1);


(lib.CowHead_moo_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CowHead_moo_001();
	this.instance.parent = this;
	this.instance.setTransform(-44.7,-44.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHead_moo_001_1, new cjs.Rectangle(-44.7,-44.3,116,85), null);


(lib.CowHead_moo_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.CowHead_moo();
	this.instance.parent = this;
	this.instance.setTransform(-44.7,-44.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHead_moo_1, new cjs.Rectangle(-44.7,-44.3,116,90), null);


(lib.CowHead_006_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CowHead_006();
	this.instance.parent = this;
	this.instance.setTransform(-48.7,-49.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHead_006_1, new cjs.Rectangle(-48.8,-49.4,110.1,101.3), null);


(lib.CowHead_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CowHead_005();
	this.instance.parent = this;
	this.instance.setTransform(-50.7,-48.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHead_005_1, new cjs.Rectangle(-50.7,-48.2,109,101), null);


(lib.CowHead_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CowHead_003();
	this.instance.parent = this;
	this.instance.setTransform(-50.4,-47.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHead_003_1, new cjs.Rectangle(-50.4,-47.4,111,96), null);


(lib.CowHead_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CowHead_001();
	this.instance.parent = this;
	this.instance.setTransform(-44.8,-44.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowHead_001_1, new cjs.Rectangle(-44.8,-44.3,116,86), null);


(lib.CowFrontLeg_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"final":4,"final_loop":5});

	// Layer 4
	this.instance = new lib.CowFrontLeg_0050001();
	this.instance.parent = this;
	this.instance.setTransform(-24.1,-86.2,0.5,0.5);

	this.instance_1 = new lib.CowFrontLeg_0050002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-24.1,-86.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[]},23).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-57.7,-86.2,107.9,178);


(lib.CowFrontLeg_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"final":4,"final_loop":5});

	// Layer 4
	this.instance = new lib.CowFrontLeg_0040001();
	this.instance.parent = this;
	this.instance.setTransform(-25,-86.1,0.5,0.5);

	this.instance_1 = new lib.CowFrontLeg_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-25,-86.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[]},23).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.7,-86.1,102.4,189.7);


(lib.CowFrontLeg_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"final":4,"final_loop":5});

	// Layer 3
	this.instance = new lib.CowFrontLeg_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-25.6,-85.9,0.5,0.5);

	this.instance_1 = new lib.CowFrontLeg_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-25.6,-85.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[]},23).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64.2,-85.9,102.8,194.6);


(lib.CowFrontLeg_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"final":4,"final_loop":5});

	// Layer 4
	this.instance = new lib.CowFrontLeg_0020001();
	this.instance.parent = this;
	this.instance.setTransform(-27,-86.1,0.5,0.5);

	this.instance_1 = new lib.CowFrontLeg_0020002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-27,-86.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[]},23).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-70.8,-86.1,107.5,197.8);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.cow_tummyMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,glowclean:101,glowclean_loop:102,"final":103,"final_loop":104});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AoDDcIgEgCIAAgIIgCgBQgQgNgSgKIgBgFIgDgDQgLgJgGgOIgFgCIgDgGQgFgJgJgCIgJgOIgFgBIgBgFQgqghgogYIgCgDQgqgkgzgPQghgsAAgpQAAgdAog6QAog7AugkQA0gpAeAQQAkATgHBmIAAARIAegTQBIgpArASQA1AXAABtIAAARQAEgFAHgEQATgMAVgCQAtgEAKArQBPhRBbg0QB9hIBOAeQBUAgAHCTQBDghAlAAQAWAAAGAGQAMAKAJAEQAbgNA5g7QA8gsBFAkQAqAWASApQAKAYAKAqQAGgBAbgTQAegTAXAAQAaAAAMA8IABAGIAUgdQAzg5AABZQAAAmgqA3QADgIAHgJIACgCIAEgLQgXASgPAbIAAABIgFACIgDAHQgRAOgUAMQgNAIgNALIgqAUQgOAHgPABIgFADQgrAEgtgGQgTAAgQgEQgpgNgogEQgmgDgpABQgggJgnAAQglgBgdAMIgFAAIgJgFQgmANg8AAIgEAAIgGADIgBgCQgPgEgPAEIgEADQguAGgsAMQgpANgrAIQgQADgQABQgiAKgnAEQgiAGgmABIgKACQhNgChxhHgAsTAIIgBAAIACAAIgBAAIAAAAg");
	this.shape.setTransform(82.4,29.3);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(28.1,34,1,1,39.2,0,0,47.6,10.2);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(50.5,28.9,1,1,61.7,0,0,48.8,4.8);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(93.9,39.9,1,1,0,0,0,50.6,5.2);

	this.instance_3 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(49.3,49.4,0.713,0.713,-165,0,0,36.6,10.8);

	this.instance_4 = new lib.cow_tummyGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(86.7,27.7,1.25,1.25,0,0,180,72.7,36.5);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(86.7,27.7,1.25,1.25,0,0,180,72.7,36.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_4}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},88).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},170).wait(31));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,164.9,58.6);


(lib.cow_neckMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:27,"clean":49});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_27 = function() {
		/* stop();*/
	}
	this.frame_49 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(27).call(this.frame_27).wait(22).call(this.frame_49).wait(11));

	// Layer 5
	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(28.4,42.8,1,1.03,0,-13.9,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(21.5,31.4,1,1,26.4,0,0,48.9,4.9);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(12.6,39.7,0.837,0.837,-104.3,0,0,50.6,5.1);

	this.instance_3 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(49.3,49.4,0.713,0.713,-165,0,0,36.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},27).to({state:[]},22).wait(11));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AB5F3IgZgUQAAAHgEAGQgJAMgYAAQgoAAgOggIgJgYQgGgMgKgCQgmgKgJgUQgEgIgBgXQgOgQgJgaQgMgtgHgRQg+AVghhtQgXhKAAhMQAAgMANgqQAMgpAEgEQAVgUAAggQgBglAHgOIAag0QAXgfArgGQATgGAPAEQAFgFAIgEQAhgRAnAuQAEAFAEAXIADAWQAAAJgPAQQgTAVgVAAQgDAAgEgEQABANAVATQAdAZANArQAQA0AEASQAHAeAAAgQAAAHAjAjQAiAhAAAlQAAAEgDAGQgEAGAAAEIAXAyIAEAJQAfAqAAAXIAAAFQAOAFAAAUQgCAUgQAAQgKAAgHgJIAAgBIgHAWIAhAbQAhAbAAAZIgGAXQgOAWgpAAQgRAAgigZg");
	this.shape.setTransform(23.3,40.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(39));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,46.6,80.1);


(lib.cow_legMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":27,"clean":50});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_27 = function() {
		/* stop();*/
	}
	this.frame_50 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(27).call(this.frame_27).wait(23).call(this.frame_50).wait(12));

	// Layer 5
	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(28.8,43.2,0.817,0.817,178.6,0,0,47.9,9.3);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(35.8,50.2,1,1,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(38.6,36.1,0.712,0.712,-26,0,0,36,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},27).to({state:[]},23).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgcETQgNgthJAPQhEAdgxhIIgcgmQgRgVgYgNQgmgVgKg1QgEgTAAg2QAAi0BuhsQBlhiBaBUQAUAeAfgiQAhgiATA8QALAwArgNQA5gNAaApQAaApAWBgQAXBgAhgHQA8BHAAATQgBAmgKAcQggBTh2gIQgEA3gHAUQgXA9hAAAIAAAAQhhAAgZhUg");
	this.shape.setTransform(35.3,40.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(41));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,4.3,70.6,71.8);


(lib.cow_backMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":72,"glowclean":73,"glowclean_loop":74,"final":75,"final_loop":76});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("Aj1CFQgFgLAAgYIABgIQg7AhghAAQgfAAgIghQgCgIAAgmIgaAJQgaAIgQAAQg7AAAAg9QAAgyBAgfQBBgfBLASIA5gBIBmgZQA4gNBKgKID9gCQC9gSA4APQAVAFAFAKQABADAAAOQAFALgLAJQgUAUhHgEQgCAIAGAQQAGATAAAJQAAAghFAQQgNADgMASQgPAWgKANQgoAvhPAAQgpAAgXgWQgMgMgIgQQhaAyhUAAQguAAgQgSIgBABQgbAygpAAQgeAAgKgXg");
	this.shape.setTransform(51,15.6);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(33.7,9.6,1,1,-15,0,0,47.6,10.1);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(51.8,10.2,1,1,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(70.9,14.4,0.713,0.713,0,0,0,36,11);

	this.instance_3 = new lib.cow_backGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(49.8,22.9,1,1,0,0,180,65.7,23.4);

	this.glow = new lib.bluelgowback();
	this.glow.parent = this;
	this.glow.setTransform(49.8,22.9,1,1,0,0,180,65.7,23.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},60).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},149).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,102.1,31.2);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.CowTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// cow_backMud_001
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(33.5,-55.6,0.804,0.804,-158.2,0,0,35.7,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2.9,-51.1,0.804,0.804,-6.4,0,0,35.9,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-37.2,-48.5,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(42));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CowTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0});

	// Layer 5
	this.tummymud = new lib.cow_tummyMud_001();
	this.tummymud.parent = this;
	this.tummymud.setTransform(19.1,37.8,1,1,0,0,0,82.4,29.6);

	this.backmud = new lib.cow_backMud_001();
	this.backmud.parent = this;
	this.backmud.setTransform(-4.3,-48.7,1,1,0,0,0,51.1,15.6);

	this.instance = new lib.CowTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-118,-67.7,0.5,0.5);

	this.instance_1 = new lib.CowTorso0003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-118,-67.7,0.5,0.5);

	this.instance_2 = new lib.CowTorso0004();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-118,-67.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backmud},{t:this.tummymud}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-118,-67.7,239,155);


(lib.CowNeckClean = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 5
	this.instance = new lib.CowNeck0002();
	this.instance.parent = this;
	this.instance.setTransform(-30.6,-42,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

	// Spots
	this.instance_1 = new lib.CowNeckSpots();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7.2,-0.1);
	this.instance_1.shadow = new cjs.Shadow("#000000",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2));

	// Neck
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AjmBfQgkhjgKg+QgHguAAhoQAAgkALg8QAPhWAaAAIByADICeAIQA/gSAZAGQAXAFAAAfIgICDQAACgBGCMQAjBHAjAtQAAANgbAjQgcAlgoAkQhoBghLAAQiCAAhukyg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.6,-52,65.1,98);


(lib.CowNeck_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-11.9,-12.6,0.804,0.804,-81.4,0,0,36,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(5.6,13,0.804,0.804,-81.4,0,0,35.9,10.3);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(5.6,21,0.804,0.804,-81.4,0,0,35.9,10.3);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-14.9,-32.4,0.573,0.573,-60,0,0,36,11.1);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-11.7,-12.7,0.573,0.573,-105,0,0,35.9,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-1,-5.9,0.573,0.573,-105,0,0,36.1,11.1);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-10,-23.7,0.573,0.573,-105,0,0,35.7,11);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(8.3,16.2,0.804,0.804,-105,0,0,35.6,11.2);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-4,5,0.804,0.804,-81.4,0,0,36,11.1);

	this.instance_9 = new lib.Bubbles_together();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-10.3,-18.7,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(43));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CowNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":131,"glowclean":132,"glowclean_loop":133,"final":134,"final_loop":135});

	// Layer 5
	this.instance = new lib.CowNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-30.6,-42,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-4.8,-2.4,1,1,-112,0,0,50.5,5.2);

	this.instance_2 = new lib.CowNeck0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-30.6,-42,0.5,0.5);

	this.instance_3 = new lib.cow_neckGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(1.1,1.3,1.25,1.25,0,0,180,28.1,32.5);

	this.glow = new lib.blueglowneck();
	this.glow.parent = this;
	this.glow.setTransform(1.1,1.3,1.25,1.25,0,0,180,28.1,32.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},118).to({state:[{t:this.instance_2}]},2).wait(2));

	// Spots
	this.instance_4 = new lib.CowNeckSpots();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-7.2,-0.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1).to({_off:true},1).wait(134));

	// Neck
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AjmBfQgkhjgKg+QgHguAAhoQAAgkALg8QAPhWAaAAIByADICeAIQA/gSAZAGQAXAFAAAfIgICDQAACgBGCMQAjBHAjAtQAAANgbAjQgcAlgoAkQhoBghLAAQiCAAhukyg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1).to({_off:true},1).wait(134));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.6,-52,65.1,98);


(lib.CowHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":86,"glowclean":87,"glowclean_loop":88,"final":89,"final_loop":90});

	// Layer 4
	this.instance = new lib.CowHindLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-28.5,-95.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(5.8,42.9,0.75,0.75,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-1.3,14.5,1,1,-60,0,0,47.6,10.1);

	this.instance_3 = new lib.left_over_bubbles_2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(169.9,41.2,1,1,0,-90,90,48.9,4.8);

	this.instance_4 = new lib.CowHindLeg0002();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-28.5,-95.7,0.5,0.5);

	this.instance_5 = new lib.cow_legGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(83.9,34.4,1.25,1.25,0,0,180,-36.7,104.2);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(83.9,34.4,1.25,1.25,0,0,180,-36.7,104.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},73).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(175));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.8,-95.7,77.3,211);


(lib.CowFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":221,"final_loop":222});

	// Layer 3
	this.instance = new lib.CowFrontLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-23.8,-80,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2.8,36,1,1,0,-90,90,48.9,4.8);

	this.instance_2 = new lib.CowFrontLegBack0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-23.8,-80,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},215).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-46.8,-80,81,174);


(lib.CowFrontLeg_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Spots
	this.instance = new lib.FrontLegSpots_001("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(6.6,-14);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Hoof
	this.instance_1 = new lib.CowHoof();
	this.instance_1.parent = this;
	this.instance_1.setTransform(5.6,88.4);
	this.instance_1.shadow = new cjs.Shadow("#000000",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Leg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhOM3QgEgFAAgHIABgGQAAgIAQgrQAQgrAAgFQAAgIgMhHIgLhEQgNgMgHgSQgHgRgCgUIAAgRIAMhEQAMhBAAgTQAAgWgdg2QgphHgYgsIgDgGQhbiqAAiGQAAheAti2QAqipAgg9QAphRAfgtQAkg0BPAlQAUAKArAaQAlAXAPAFQBPA4AVBGQAKAiAABcQAAC3gbCFQgTBZgqBqQgeBMgRAwQgJAbgEASQgcBoAACFQAAAIAIAOQAIAPAAARQAAAggUAiQgRAdgaANQgNAnAAAkQAAA/AUAyIAUAxQAAAQgHAFQgQANg0AAQg6AAgPgSg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.CowFrontLeg_001, new cjs.Rectangle(-26.6,-84.1,60.4,198.6), null);


(lib.CowFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":200,"final":201,"final_loop":202});

	// Layer 3
	this.instance = new lib.CowFrontLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-28.8,-86,0.5,0.5);

	this.instance_1 = new lib.CowFrontLeg0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-28.8,-86,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-136.2,45.8,0.75,0.75,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles_sparse();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-143.3,17.4,1,1,-60,0,0,47.6,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.instance_3},{t:this.instance_2}]},44).to({state:[{t:this.instance_1}]},151).to({state:[]},2).wait(19));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-80,-86,117.2,196);


(lib.water_drops_014 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(185.8,10.7,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(174.5,47.7,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(20,71.3,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(42.4,57.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(214.7,42.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.cow_tummyMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":75});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(107.3,8,0.804,0.804,163.3,0,0,36.2,11.4);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(106.5,16.3,0.804,0.804,-158.2,0,0,36,11.3);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(113,14,0.804,0.804,-158.2,0,0,35.8,11.3);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(14.6,2,0.804,0.804,-158.2,0,0,35.6,11.6);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-10.6,27.2,0.713,0.713,0,0,0,36,11);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(22.5,28.5,0.804,0.804,-158.2,0,0,35.6,11.2);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(50.3,25.6,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(44.3,4.6,0.804,0.804,-158.2,0,0,36,11.3);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-20.7,5.3,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).to({state:[]},75).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-51.3,-26.6,198.2,93.3);


(lib.cow_neckMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":50});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_50 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(6).call(this.frame_50).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(16.7,37.4,0.804,0.804,-81.4,0,0,36,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(34.2,63,0.804,0.804,-81.4,0,0,35.9,10.3);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(34.2,71,0.804,0.804,-81.4,0,0,35.9,10.3);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(13.7,17.5,0.573,0.573,-60,0,0,36,11);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(16.9,37.3,0.573,0.573,-105,0,0,35.9,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(27.6,44.1,0.573,0.573,-105,0,0,36.1,11.1);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(18.7,26.3,0.573,0.573,-105,0,0,35.6,11);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(36.9,66.2,0.804,0.804,-105,0,0,35.6,11.2);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(24.6,55,0.804,0.804,-81.4,0,0,36,11.1);

	this.instance_9 = new lib.Bubbles_together();
	this.instance_9.parent = this;
	this.instance_9.setTransform(18.3,31.3,0.713,0.713,0,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.cow_legMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":50});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_50 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(6).call(this.frame_50).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(206.3,68.5,0.804,0.804,93.1,0,0,35.6,11.1);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(175.8,68.7,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(43.7,74.4,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_3 = new lib.Bubbles_together("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(17.8,45.6,0.804,0.804,-158.2,0,0,36,11.2);

	this.instance_4 = new lib.Bubbles_together("synched",0,false);
	this.instance_4.parent = this;
	this.instance_4.setTransform(25.1,14.7,0.713,0.713,0,0,0,36,11.1);

	this.instance_5 = new lib.Bubbles_together("synched",0,false);
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.8,38.9,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_6 = new lib.Bubbles_together("synched",0,false);
	this.instance_6.parent = this;
	this.instance_6.setTransform(50.9,17,0.713,0.713,0,0,0,36,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.cow_backMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":43,"clean":49});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_43 = function() {
		/* stop();*/
	}
	this.frame_49 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(43).call(this.frame_43).wait(6).call(this.frame_49).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(80.4,9.2,0.804,0.804,-158.2,0,0,35.7,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(44,13.7,0.804,0.804,-6.4,0,0,35.9,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(9.7,16.3,0.713,0.713,0,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},42).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CowHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":69});

	// Layer 2
	this.instance = new lib.cow_legMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(0.4,18,1,1,0,0,0,35.2,38);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(175.4,37,0.804,0.804,93.1,0,0,35.6,11.1);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(144.9,37.2,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_3 = new lib.Bubbles_together("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(12.8,42.9,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_4 = new lib.Bubbles_together("synched",0,false);
	this.instance_4.parent = this;
	this.instance_4.setTransform(-13.1,14.1,0.804,0.804,-158.2,0,0,36,11.2);

	this.instance_5 = new lib.Bubbles_together("synched",0,false);
	this.instance_5.parent = this;
	this.instance_5.setTransform(-5.8,-16.9,0.713,0.713,0,0,0,36,11);

	this.instance_6 = new lib.Bubbles_together("synched",0,false);
	this.instance_6.parent = this;
	this.instance_6.setTransform(24.9,7.4,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_7 = new lib.Bubbles_together("synched",0,false);
	this.instance_7.parent = this;
	this.instance_7.setTransform(20,-14.5,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},1).to({state:[]},68).wait(53));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Cow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:36,rest_stop:158,wet:160,wet_stop:184,"clean":186,clean_stop:204,excited:206,excited_stop:333,animalSound:335});

	// timeline functions:
	this.frame_34 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_158 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_184 = function() {
		/* stop();*/
	}
	this.frame_204 = function() {
		/* stop();*/
	}
	this.frame_332 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_397 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(34).call(this.frame_34).wait(124).call(this.frame_158).wait(26).call(this.frame_184).wait(20).call(this.frame_204).wait(128).call(this.frame_332).wait(65).call(this.frame_397).wait(2));

	// neck bubbles
	this.neck_bubbles = new lib.CowNeck_bubbles();
	this.neck_bubbles.parent = this;
	this.neck_bubbles.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles).wait(36).to({_off:true},124).wait(239));

	// Cow Torso
	this.back_bubbles = new lib.CowTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(444.3,155.1,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(36).to({_off:true},124).wait(239));

	// Cow Hind Leg
	this.legs_bubbles = new lib.CowHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(516.9,179.2,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(36).to({_off:true},124).wait(239));

	// Cow Torso
	this.tummy_bubbles = new lib.cow_tummyMud_001_bubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(460.8,201.4,1,1,0,0,0,53.1,29.6);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).wait(36).to({_off:true},124).wait(239));

	// Layer 4
	this.instance = new lib.water_drops_014();
	this.instance.parent = this;
	this.instance.setTransform(420.9,171.3,1,1,0,0,180,132.3,67);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(160).to({_off:false},0).to({_off:true},26).wait(213));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(394.9,147.5,0.461,0.461);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(326).to({_off:false},0).to({_off:true},9).wait(64));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(334.2,126.1,0.679,0.679);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(314).to({_off:false},0).to({_off:true},21).wait(64));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(528.7,171.4,0.679,0.679);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(300).to({_off:false},0).to({_off:true},35).wait(64));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(453.6,138.9,0.679,0.679);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(290).to({_off:false},0).to({_off:true},45).wait(64));

	// Cow Head_001
	this.instance_5 = new lib.CowHead_001_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(327.2,128.5,0.923,0.923,0,0,180);

	this.instance_6 = new lib.CowHead_003_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(345.5,128.5,0.995,0.995,0,0,180,-17.3,0);
	this.instance_6._off = true;

	this.instance_7 = new lib.CowHead_005_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(345.5,128.5,1.04,1.04,0,0,180,-17.3,0);

	this.instance_8 = new lib.CowHead_006_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(345.6,128.5,1.063,1.063,0,0,180,-17.3,0);
	this.instance_8._off = true;

	this.instance_9 = new lib.CowHead_moo_001_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(295,122.2,0.923,0.923,0,11.7,-168.3);
	this.instance_9._off = true;

	this.instance_10 = new lib.CowHead_moo_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(305.5,104.1,0.923,0.923,0,40.4,-139.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},4).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_7}]},18).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},10).to({state:[{t:this.instance_6}]},9).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},27).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},8).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_7}]},40).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},20).to({state:[{t:this.instance_5}]},26).to({state:[{t:this.instance_5}]},20).to({state:[{t:this.instance_5}]},18).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},6).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_9}]},18).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},51).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},6).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_9}]},13).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_8}]},2).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},4).wait(22).to({_off:false},0).wait(10).to({_off:true},9).wait(95).to({_off:false},0).wait(88).to({skewX:-3.6,skewY:176.4,y:128.1},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.3,skewY:172.7,x:327.3,y:127.8},0).wait(2).to({skewX:-11.1,skewY:168.9,y:127.4},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-14.9,skewY:165.1,y:127},0).wait(6).to({skewX:-36.9,skewY:143.1,x:328.3,y:137.6},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-53.4,skewY:126.6,x:330.4,y:143.7},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-70,skewY:110,x:332.6,y:149.9},0).wait(2).to({skewX:-59.8,skewY:120.2,x:315.1,y:155.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24,skewY:156,x:305,y:138.8},0).to({_off:true},2).wait(24).to({_off:false,scaleX:0.92,scaleY:0.92,skewX:-27.7,skewY:152.3,x:303.4,y:138},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24.3,skewY:155.7,x:310.7,y:137.3},0).wait(2).to({skewX:-20.8,skewY:159.2,x:318,y:136.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-17.4,skewY:162.6,x:325.3,y:135.8},0).to({_off:true},2).wait(54).to({_off:false,skewX:0,skewY:180,x:327.2,y:128.5},0).wait(4).to({skewX:-3.6,skewY:176.4,y:128.1},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.3,skewY:172.7,x:327.3,y:127.8},0).wait(2).to({skewX:-11.1,skewY:168.9,y:127.4},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-14.9,skewY:165.1,y:127},0).wait(6).to({skewX:-36.9,skewY:143.1,x:328.3,y:137.6},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-53.4,skewY:126.6,x:330.4,y:143.7},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-70,skewY:110,x:332.6,y:149.9},0).wait(2).to({skewX:-59.8,skewY:120.2,x:315.1,y:155.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24,skewY:156,x:305,y:138.8},0).to({_off:true},2).wait(19).to({_off:false,scaleX:0.92,scaleY:0.92,skewX:-27.7,skewY:152.3,x:303.4,y:138},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24.3,skewY:155.7,x:310.7,y:137.3},0).wait(2).to({skewX:-20.8,skewY:159.2,x:318,y:136.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-17.4,skewY:162.6,x:325.3,y:135.8},0).to({_off:true},2).wait(10));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(4).to({_off:false},0).to({_off:true},1).wait(20).to({_off:false},0).to({_off:true},1).wait(19).to({_off:false},0).to({_off:true},1).wait(93).to({_off:false},0).to({_off:true},1).wait(142).to({_off:false,regY:0.2,skewX:-9.9,skewY:170.1,x:343.5,y:127.6},0).to({_off:true},2).wait(105).to({_off:false},0).to({_off:true},2).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(6).to({_off:false},0).to({_off:true},18).wait(23).to({_off:false},0).wait(29).to({regY:0.3,skewX:0.3,skewY:180.3,x:345.3,y:128.1},0).wait(2).to({regY:0,skewX:0.5,skewY:180.5,x:345,y:126.9},0).wait(2).to({regY:0.2,skewX:0.8,skewY:180.8,x:344.7,y:126.3},0).wait(2).to({regY:0.1,skewX:1,skewY:181,x:344.3,y:125.3},0).wait(10).to({regX:-17.4,regY:2.9,skewX:0.8,skewY:180.8,x:344.7,y:129.1},0).wait(2).to({regX:-17.3,regY:0.1,skewX:0.5,skewY:180.5,x:345,y:126.9},0).wait(2).to({regX:-17.2,skewX:0.3,skewY:180.3,x:345.2,y:127.8},0).wait(2).to({regX:-17.3,regY:0,skewX:0,skewY:180,x:345.6,y:128.5},0).to({_off:true},40).wait(146).to({_off:false},0).wait(51).to({_off:true},1).wait(55).to({_off:false},0).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(250).to({_off:false},0).to({_off:true},2).wait(18).to({_off:false,x:294,y:128.8},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.8,skewY:-187.8,x:298.8,y:133.4},0).to({_off:true},2).wait(88).to({_off:false,scaleX:0.92,scaleY:0.92,skewX:11.7,skewY:-168.3,x:295,y:122.2},0).to({_off:true},2).wait(13).to({_off:false,x:294,y:128.8},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.8,skewY:-187.8,x:298.8,y:133.4},0).to({_off:true},2).wait(18));

	// Cow Neck
	this.cow_neck = new lib.CowNeck();
	this.cow_neck.parent = this;
	this.cow_neck.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);

	this.cow_neck_1 = new lib.CowNeckClean();
	this.cow_neck_1.parent = this;
	this.cow_neck_1.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);

	this.cow_frontleg = new lib.CowFrontLeg_001();
	this.cow_frontleg.parent = this;
	this.cow_frontleg.setTransform(402.2,185.1,0.81,0.81,0,0,180);
	this.cow_frontleg._off = true;

	this.cow_frontleg_1 = new lib.CowFrontLeg_002();
	this.cow_frontleg_1.parent = this;
	this.cow_frontleg_1.setTransform(401.9,184.8,0.81,0.81,0,0,180);

	this.cow_frontleg_2 = new lib.CowFrontLeg_003();
	this.cow_frontleg_2.parent = this;
	this.cow_frontleg_2.setTransform(401.6,184.5,0.81,0.81,0,0,180);

	this.cow_frontleg_3 = new lib.CowFrontLeg_004();
	this.cow_frontleg_3.parent = this;
	this.cow_frontleg_3.setTransform(401.3,184.2,0.81,0.81,0,0,180);

	this.cow_frontleg_4 = new lib.CowFrontLeg_005();
	this.cow_frontleg_4.parent = this;
	this.cow_frontleg_4.setTransform(401,183.9,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cow_neck}]}).to({state:[{t:this.cow_neck}]},4).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},18).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},10).to({state:[{t:this.cow_neck}]},8).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},27).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},8).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},2).to({state:[{t:this.cow_neck}]},40).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},1).to({state:[{t:this.cow_neck}]},20).to({state:[{t:this.cow_neck}]},26).to({state:[{t:this.cow_neck_1,p:{scaleX:0.963,scaleY:0.814,skewX:-5.8}}]},20).to({state:[{t:this.cow_frontleg}]},18).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg_1,p:{regX:0,regY:0,skewX:0,x:401.9,y:184.8}}]},2).to({state:[{t:this.cow_frontleg_2,p:{regX:0,regY:0,skewX:0,x:401.6,y:184.5}}]},2).to({state:[{t:this.cow_frontleg_3,p:{regX:0,regY:0,skewX:0,x:401.3,y:184.2}}]},2).to({state:[{t:this.cow_frontleg_4}]},2).to({state:[{t:this.cow_frontleg_4}]},4).to({state:[{t:this.cow_frontleg_3,p:{regX:5.2,regY:86.4,skewX:-2.1,x:401.1,y:254.2}}]},2).to({state:[{t:this.cow_frontleg_2,p:{regX:-5.2,regY:91.4,skewX:-1.6,x:406.8,y:258.5}}]},2).to({state:[{t:this.cow_frontleg_1,p:{regX:0.1,regY:95,skewX:-2.1,x:401.7,y:261.7}}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},22).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_neck_1,p:{scaleX:0.81,scaleY:0.81,skewX:0}}]},2).to({state:[{t:this.cow_neck}]},47).to({state:[{t:this.cow_frontleg}]},1).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg_1,p:{regX:0,regY:0,skewX:0,x:401.9,y:184.8}}]},2).to({state:[{t:this.cow_frontleg_2,p:{regX:0,regY:0,skewX:0,x:401.6,y:184.5}}]},2).to({state:[{t:this.cow_frontleg_3,p:{regX:0,regY:0,skewX:0,x:401.3,y:184.2}}]},2).to({state:[{t:this.cow_frontleg_4}]},2).to({state:[{t:this.cow_frontleg_4}]},4).to({state:[{t:this.cow_frontleg_3,p:{regX:5.2,regY:86.4,skewX:-2.1,x:401.1,y:254.2}}]},2).to({state:[{t:this.cow_frontleg_2,p:{regX:-5.3,regY:91.4,skewX:-1.6,x:406.9,y:258.5}}]},2).to({state:[{t:this.cow_frontleg_1,p:{regX:0.1,regY:95,skewX:-2.1,x:401.7,y:261.7}}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},17).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_frontleg}]},2).to({state:[{t:this.cow_neck}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_neck).wait(4).to({regX:-16.7,regY:9.7,scaleX:0.91,scaleY:0.81,skewX:-3.8,x:371.1,y:142.5},0).wait(1).to({regX:-16.6,regY:9.6,scaleX:0.86,scaleY:0.81,skewX:-1.8,x:371,y:142.4},0).wait(1).to({scaleX:0.81,scaleY:0.81,skewX:0},0).wait(18).to({scaleX:0.86,scaleY:0.81,skewX:-1.8},0).wait(1).to({regX:-16.7,regY:9.7,scaleX:0.91,scaleY:0.81,skewX:-3.8,x:371.1,y:142.5},0).wait(1).to({regX:-16.6,regY:9.6,scaleX:0.96,scaleY:0.81,skewX:-5.8,x:371,y:142.4},0).wait(19).to({regX:-16.7,regY:9.7,scaleX:0.91,scaleY:0.81,skewX:-3.8,x:371.1,y:142.5},0).wait(1).to({regX:-16.6,regY:9.6,scaleX:0.86,scaleY:0.81,skewX:-1.8,x:371,y:142.4},0).wait(1).to({scaleX:0.81,scaleY:0.81,skewX:0},0).wait(29).to({regY:6.2,x:370.5,y:139.2},0).wait(2).to({regX:-16.7,regY:9.6,skewX:0.3,skewY:180.3,x:370,y:141.4},0).wait(2).to({regX:-16.6,skewX:0.5,skewY:180.5,x:369.5,y:140.9},0).wait(2).to({regX:-16.7,skewX:0.8,skewY:180.8,x:369,y:140.5},0).wait(10).to({regX:-16.6,skewX:0.5,skewY:180.5,x:369.5,y:140.9},0).wait(2).to({regX:-16.7,skewX:0.3,skewY:180.3,x:370,y:141.4},0).wait(2).to({regX:-16.6,regY:6.2,skewX:0,skewY:180,x:370.5,y:139.2},0).wait(2).to({regY:9.6,x:371,y:142.4},0).wait(40).to({scaleX:0.86,scaleY:0.81,skewX:-1.8},0).wait(1).to({scaleX:0.91,scaleY:0.81,skewX:-3.8,y:142.5},0).wait(1).to({scaleX:0.96,scaleY:0.81,skewX:-5.8,y:142.4},0).wait(46).to({_off:true},20).wait(129).to({_off:false,scaleX:0.81,scaleY:0.81,skewX:0},0).to({_off:true},1).wait(59).to({_off:false},0).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_frontleg).wait(224).to({_off:false},0).wait(2).to({_off:true},2).wait(18).to({_off:false,regY:98.8,scaleY:0.81,skewX:-3.5,y:265.1},0).wait(2).to({scaleY:0.82,skewX:-7},0).wait(2).to({scaleY:0.82,skewX:-9.3},0).wait(24).to({regX:-0.1,regY:98.6,scaleY:0.82,skewX:-7.6,y:265},0).wait(2).to({regY:98.7,scaleY:0.82,skewX:-6,x:402.3},0).wait(2).to({regX:0,regY:98.8,scaleY:0.82,skewX:-4.5,x:402.2,y:265.1},0).wait(2).to({regX:-0.1,regY:98.7,scaleY:0.81,skewX:-3,x:402.3},0).wait(2).to({regY:98.8,scaleY:0.81,skewX:-1.3},0).wait(2).to({regX:0,scaleY:0.81,skewX:0.1,x:402.2},0).wait(2).to({regY:0,skewX:0,y:185.1},0).to({_off:true},2).wait(48).to({_off:false},0).wait(2).to({_off:true},2).wait(18).to({_off:false,regY:98.8,scaleY:0.81,skewX:-3.5,y:265.1},0).wait(2).to({scaleY:0.82,skewX:-7},0).wait(2).to({scaleY:0.82,skewX:-9.3},0).wait(19).to({regX:-0.1,regY:98.6,scaleY:0.82,skewX:-7.6,y:265},0).wait(2).to({regY:98.7,scaleY:0.82,skewX:-6,x:402.3},0).wait(2).to({regX:0,regY:98.8,scaleY:0.82,skewX:-4.5,x:402.2,y:265.1},0).wait(2).to({regX:-0.1,regY:98.7,scaleY:0.81,skewX:-3,x:402.3},0).wait(2).to({regY:98.8,scaleY:0.81,skewX:-1.3},0).wait(2).to({regX:0,scaleY:0.81,skewX:0.1,x:402.2},0).wait(2).to({regY:0,skewX:0,y:185.1},0).to({_off:true},2).wait(4));

	// Cow Hind Leg
	this.cow_hindleg = new lib.CowHindLeg();
	this.cow_hindleg.parent = this;
	this.cow_hindleg.setTransform(516.9,179.2,0.81,0.81,0,0,180);

	this.cow_hindleg_1 = new lib.CowHindLegClean();
	this.cow_hindleg_1.parent = this;
	this.cow_hindleg_1.setTransform(516.9,179.2,0.81,0.81,0,0,180);

	this.cow_neck_2 = new lib.CowNeckClean();
	this.cow_neck_2.parent = this;
	this.cow_neck_2.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);
	this.cow_neck_2._off = true;

	this.cow_neck_3 = new lib.CowNeck();
	this.cow_neck_3.parent = this;
	this.cow_neck_3.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);
	this.cow_neck_3._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cow_hindleg}]}).to({state:[{t:this.cow_hindleg}]},36).to({state:[{t:this.cow_hindleg}]},38).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},8).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},2).to({state:[{t:this.cow_hindleg}]},62).to({state:[{t:this.cow_hindleg}]},26).to({state:[{t:this.cow_hindleg_1}]},20).to({state:[{t:this.cow_neck_2}]},18).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},6).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},18).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_neck_2}]},2).to({state:[{t:this.cow_hindleg_1}]},4).to({state:[{t:this.cow_hindleg_1}]},47).to({state:[{t:this.cow_neck_3}]},1).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},6).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},13).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_neck_3}]},2).to({state:[{t:this.cow_hindleg}]},4).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_hindleg).wait(76).to({skewX:-0.1,x:516.6},0).wait(2).to({skewX:-0.3,x:516.3},0).wait(2).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.8,x:515.7},0).wait(10).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.3,x:516.4},0).wait(2).to({skewX:-0.1,x:516.7},0).wait(2).to({skewX:0,x:516.9},0).wait(88).to({_off:true},20).wait(189).to({_off:false},0).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_neck_2).wait(224).to({_off:false},0).wait(4).to({scaleX:0.94,scaleY:0.81,skewX:-4.8,skewY:179.7,x:370.4,y:142.2},0).wait(2).to({regX:-16.7,scaleX:0.91,scaleY:0.81,skewX:-3.6,skewY:179.2,x:369.7,y:142},0).wait(2).to({regX:-17,scaleX:0.89,scaleY:0.81,skewX:-2.6,skewY:178.7,x:369.4,y:141.6},0).wait(2).to({regX:-16.9,scaleX:0.87,scaleY:0.81,skewX:-1.7,skewY:178.3,x:368.4,y:141.4},0).wait(6).to({regY:9.5,skewX:-8.2,skewY:171.8},0).wait(2).to({regX:-17.1,scaleX:0.89,scaleY:0.81,skewX:-17,skewY:165.7,x:368.1,y:144.5},0).wait(2).to({regX:-17,regY:9.2,scaleX:0.92,scaleY:0.81,skewX:-26,skewY:159.5,x:367.4,y:147.5},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.22,scaleY:0.84,skewX:-28.8,skewY:161.5,x:362.5,y:146.4},0).wait(2).to({scaleX:1.24,scaleY:0.83,skewX:-13.3,skewY:175.7,x:355.3,y:144.9},0).wait(2).to({regX:-17.1,regY:9.3,scaleX:1.26,scaleY:0.83,skewX:1.8,skewY:189.7,x:348,y:143.5},0).wait(2).to({regX:-17.2,scaleX:1.31,scaleY:0.83,skewX:4.6,skewY:202.5,x:348.6,y:143.8},0).wait(18).to({regX:-17,regY:9.7,scaleX:1.26,scaleY:0.76,skewX:-7.4,skewY:180.5,x:349.3,y:143.2},0).wait(2).to({regY:9.8,scaleX:1.14,scaleY:0.8,skewX:-9,skewY:178.5,x:351.2,y:144.9},0).wait(2).to({regX:-16.9,scaleX:1.02,scaleY:0.85,skewX:-10.7,skewY:176.1,x:353.1,y:146.1},0).wait(2).to({regX:-16.7,regY:10,scaleX:1.02,scaleY:0.82,skewX:-10.6,skewY:174,x:357.8,y:144.7},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.01,scaleY:0.79,skewY:171.7,x:362.9,y:143},0).wait(2).to({regY:9.8,scaleX:1.01,scaleY:0.76,skewX:-10.7,skewY:169.3,x:367.9,y:141.4},0).wait(2).to({regX:-16.8,scaleX:0.91,scaleY:0.79,skewX:-5.3,skewY:174.7,x:369.3,y:142},0).wait(2).to({regX:-16.6,regY:9.6,scaleX:0.81,scaleY:0.81,skewX:0,skewY:180,x:371,y:142.4},0).to({_off:true},4).wait(111));
	this.timeline.addTween(cjs.Tween.get(this.cow_neck_3).wait(336).to({_off:false},0).wait(4).to({scaleX:0.94,scaleY:0.81,skewX:-4.8,skewY:179.7,x:370.4,y:142.2},0).wait(2).to({regX:-16.7,scaleX:0.91,scaleY:0.81,skewX:-3.6,skewY:179.2,x:369.7,y:142},0).wait(2).to({regX:-17,scaleX:0.89,scaleY:0.81,skewX:-2.6,skewY:178.7,x:369.4,y:141.6},0).wait(2).to({regX:-16.9,scaleX:0.87,scaleY:0.81,skewX:-1.7,skewY:178.3,x:368.4,y:141.4},0).wait(6).to({regY:9.5,skewX:-8.2,skewY:171.8},0).wait(2).to({regX:-17.1,scaleX:0.89,scaleY:0.81,skewX:-17,skewY:165.7,x:368.1,y:144.5},0).wait(2).to({regX:-17,regY:9.2,scaleX:0.92,scaleY:0.81,skewX:-26,skewY:159.5,x:367.4,y:147.5},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.22,scaleY:0.84,skewX:-28.8,skewY:161.5,x:362.5,y:146.4},0).wait(2).to({scaleX:1.24,scaleY:0.83,skewX:-13.3,skewY:175.7,x:355.3,y:144.9},0).wait(2).to({regX:-17.1,regY:9.3,scaleX:1.26,scaleY:0.83,skewX:1.8,skewY:189.7,x:348,y:143.5},0).wait(2).to({regX:-17.2,scaleX:1.31,scaleY:0.83,skewX:4.6,skewY:202.5,x:348.6,y:143.8},0).wait(13).to({regX:-17,regY:9.7,scaleX:1.26,scaleY:0.76,skewX:-7.4,skewY:180.5,x:349.3,y:143.2},0).wait(2).to({regY:9.8,scaleX:1.14,scaleY:0.8,skewX:-9,skewY:178.5,x:351.2,y:144.9},0).wait(2).to({regX:-16.9,scaleX:1.02,scaleY:0.85,skewX:-10.7,skewY:176.1,x:353.1,y:146.1},0).wait(2).to({regX:-16.7,regY:10,scaleX:1.02,scaleY:0.82,skewX:-10.6,skewY:174,x:357.8,y:144.7},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.01,scaleY:0.79,skewY:171.7,x:362.9,y:143},0).wait(2).to({regY:9.8,scaleX:1.01,scaleY:0.76,skewX:-10.7,skewY:169.3,x:367.9,y:141.4},0).wait(2).to({regX:-16.8,scaleX:0.91,scaleY:0.79,skewX:-5.3,skewY:174.7,x:369.3,y:142},0).wait(2).to({regX:-16.6,regY:9.6,scaleX:0.81,scaleY:0.81,skewX:0,skewY:180,x:371,y:142.4},0).to({_off:true},4).wait(4));

	// Cow Front Leg
	this.cow_frontleg_5 = new lib.CowFrontLeg();
	this.cow_frontleg_5.parent = this;
	this.cow_frontleg_5.setTransform(402.2,185.1,0.81,0.81,0,0,180);

	this.cow_frontleg_6 = new lib.CowFrontLeg_002();
	this.cow_frontleg_6.parent = this;
	this.cow_frontleg_6.setTransform(401.9,184.8,0.81,0.81,0,0,180);

	this.cow_frontleg_7 = new lib.CowFrontLeg_003();
	this.cow_frontleg_7.parent = this;
	this.cow_frontleg_7.setTransform(401.6,184.5,0.81,0.81,0,0,180);

	this.cow_frontleg_8 = new lib.CowFrontLeg_004();
	this.cow_frontleg_8.parent = this;
	this.cow_frontleg_8.setTransform(401.3,184.2,0.81,0.81,0,0,180);

	this.cow_frontleg_9 = new lib.CowFrontLeg_005();
	this.cow_frontleg_9.parent = this;
	this.cow_frontleg_9.setTransform(401,183.9,0.81,0.81,0,0,180);

	this.cow_frontleg_10 = new lib.CowFrontLeg_001();
	this.cow_frontleg_10.parent = this;
	this.cow_frontleg_10.setTransform(402.2,185.1,0.81,0.81,0,0,180);
	this.cow_frontleg_10._off = true;

	this.cow_hindleg_2 = new lib.CowHindLegClean();
	this.cow_hindleg_2.parent = this;
	this.cow_hindleg_2.setTransform(516.9,179.2,0.81,0.81,0,0,180);
	this.cow_hindleg_2._off = true;

	this.cow_hindleg_3 = new lib.CowHindLeg();
	this.cow_hindleg_3.parent = this;
	this.cow_hindleg_3.setTransform(516.9,179.2,0.81,0.81,0,0,180);
	this.cow_hindleg_3._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cow_frontleg_5}]}).to({state:[{t:this.cow_frontleg_5}]},36).to({state:[{t:this.cow_frontleg_5}]},38).to({state:[{t:this.cow_frontleg_6}]},2).to({state:[{t:this.cow_frontleg_7}]},2).to({state:[{t:this.cow_frontleg_8}]},2).to({state:[{t:this.cow_frontleg_9}]},2).to({state:[{t:this.cow_frontleg_9}]},8).to({state:[{t:this.cow_frontleg_8}]},2).to({state:[{t:this.cow_frontleg_7}]},2).to({state:[{t:this.cow_frontleg_6}]},2).to({state:[{t:this.cow_frontleg_5}]},2).to({state:[{t:this.cow_frontleg_10}]},62).to({state:[{t:this.cow_frontleg_10}]},26).to({state:[{t:this.cow_frontleg_10}]},20).to({state:[{t:this.cow_hindleg_2}]},18).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},8).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},22).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_hindleg_2}]},2).to({state:[{t:this.cow_frontleg_10}]},2).to({state:[{t:this.cow_frontleg_10}]},47).to({state:[{t:this.cow_hindleg_3}]},1).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},8).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},17).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_hindleg_3}]},2).to({state:[{t:this.cow_frontleg_10}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_frontleg_5).wait(74).to({_off:true},2).wait(22).to({_off:false},0).to({_off:true},62).wait(239));
	this.timeline.addTween(cjs.Tween.get(this.cow_frontleg_10).wait(160).to({_off:false},0).wait(46).to({_off:true},18).wait(64).to({_off:false},0).wait(47).to({_off:true},1).wait(59).to({_off:false},0).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_hindleg_2).wait(224).to({_off:false},0).wait(4).to({skewX:-0.1,x:516.6},0).wait(2).to({skewX:-0.3,x:516.3},0).wait(2).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.8,x:515.7},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:513.2},0).wait(2).to({scaleY:0.81,skewX:-4,x:510.8},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:508.4},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:505.9},0).wait(24).to({scaleY:0.82,skewX:-6.1,x:507.8,y:179.1},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:509.6,y:179.2},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:511.5},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:513.3},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:515.1},0).wait(2).to({scaleY:0.81,skewX:0,x:516.9},0).wait(2).to({_off:true},2).wait(111));
	this.timeline.addTween(cjs.Tween.get(this.cow_hindleg_3).wait(336).to({_off:false},0).wait(4).to({skewX:-0.1,x:516.6},0).wait(2).to({skewX:-0.3,x:516.3},0).wait(2).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.8,x:515.7},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:513.2},0).wait(2).to({scaleY:0.81,skewX:-4,x:510.8},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:508.4},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:505.9},0).wait(19).to({scaleY:0.82,skewX:-6.1,x:507.8,y:179.1},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:509.6,y:179.2},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:511.5},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:513.3},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:515.1},0).wait(2).to({scaleY:0.81,skewX:0,x:516.9},0).wait(2).to({_off:true},2).wait(4));

	// Cow Torso
	this.cow_torso = new lib.CowTorso();
	this.cow_torso.parent = this;
	this.cow_torso.setTransform(444.3,155.1,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.cow_torso).wait(76).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:1,skewY:181,x:442.4,y:153.7},0).wait(10).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0,skewY:180,x:444.3,y:155.1},0).wait(130).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:1,skewY:181,x:442.4,y:153.7},0).wait(10).to({skewX:0.8,skewY:180.8,x:437.2,y:154.2},0).wait(2).to({skewX:0.5,skewY:180.5,x:432.1,y:154.7},0).wait(2).to({skewX:0.3,skewY:180.3,x:426.9,y:155.2},0).wait(2).to({skewX:0,skewY:180,x:421.7,y:155.7},0).wait(24).to({x:425.4,y:155.6},0).wait(2).to({x:429.2,y:155.5},0).wait(2).to({x:433,y:155.4},0).wait(2).to({x:436.7,y:155.3},0).wait(2).to({x:440.5,y:155.2},0).wait(2).to({x:444.3,y:155.1},0).wait(56).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:1,skewY:181,x:442.4,y:153.7},0).wait(10).to({skewX:0.8,skewY:180.8,x:437.2,y:154.2},0).wait(2).to({skewX:0.5,skewY:180.5,x:432.1,y:154.7},0).wait(2).to({skewX:0.3,skewY:180.3,x:426.9,y:155.2},0).wait(2).to({skewX:0,skewY:180,x:421.7,y:155.7},0).wait(19).to({x:425.4,y:155.6},0).wait(2).to({x:429.2,y:155.5},0).wait(2).to({x:433,y:155.4},0).wait(2).to({x:436.7,y:155.3},0).wait(2).to({x:440.5,y:155.2},0).wait(2).to({x:444.3,y:155.1},0).wait(8));

	// Cow Tail
	this.instance_11 = new lib.CowTail();
	this.instance_11.parent = this;
	this.instance_11.setTransform(534.3,173.4,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(76).to({x:535.3,y:172.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.3,y:172.1},0).wait(2).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:538.2,y:170.8},0).wait(10).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.2,y:172.1},0).wait(2).to({skewX:0,skewY:180,x:535.3,y:172.8},0).wait(2).to({x:534.3,y:173.4},0).wait(130).to({x:535.3,y:172.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.3,y:172.1},0).wait(2).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:538.2,y:170.8},0).wait(10).to({skewX:-0.3,skewY:179.7,x:535,y:171.5},0).wait(2).to({skewX:-0.1,skewY:179.9,x:531.7,y:172.1},0).wait(2).to({skewX:0,skewY:180,x:528.5,y:172.8},0).wait(2).to({x:525.3,y:173.4},0).wait(24).to({x:526.8},0).wait(2).to({x:528.3},0).wait(2).to({x:529.8},0).wait(2).to({x:531.3},0).wait(2).to({x:532.8},0).wait(2).to({x:534.3},0).wait(56).to({x:535.3,y:172.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.3,y:172.1},0).wait(2).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:538.2,y:170.8},0).wait(10).to({skewX:-0.3,skewY:179.7,x:535,y:171.5},0).wait(2).to({skewX:-0.1,skewY:179.9,x:531.7,y:172.1},0).wait(2).to({skewX:0,skewY:180,x:528.5,y:172.8},0).wait(2).to({x:525.3,y:173.4},0).wait(19).to({x:526.8},0).wait(2).to({x:528.3},0).wait(2).to({x:529.8},0).wait(2).to({x:531.3},0).wait(2).to({x:532.8},0).wait(2).to({x:534.3},0).wait(8));

	// Cow Front Leg Back
	this.cow_frontlegback = new lib.CowFrontLegBack();
	this.cow_frontlegback.parent = this;
	this.cow_frontlegback.setTransform(375.2,191.4,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.cow_frontlegback).wait(242).to({regY:82.8,y:258.5},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-3.5,x:375.3},0).wait(2).to({scaleY:0.82,skewX:-7.1},0).wait(2).to({scaleY:0.83,skewX:-10.8,y:258.4},0).wait(2).to({regX:0,scaleY:0.84,skewX:-14.4,x:375.2,y:258.5},0).wait(24).to({regX:-0.1,scaleY:0.83,skewX:-11.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.83,skewX:-9.5,y:258.5},0).wait(2).to({regX:0.1,scaleY:0.82,skewX:-7.1,x:375.1},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-4.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.81,skewX:-2.3,y:258.5},0).wait(2).to({regX:0,scaleY:0.81,skewX:0,x:375.2},0).wait(4).to({regY:0,y:191.4},0).wait(66).to({regY:82.8,y:258.5},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-3.5,x:375.3},0).wait(2).to({scaleY:0.82,skewX:-7.1},0).wait(2).to({scaleY:0.83,skewX:-10.8,y:258.4},0).wait(2).to({regX:0,scaleY:0.84,skewX:-14.4,x:375.2,y:258.5},0).wait(19).to({regX:-0.1,scaleY:0.83,skewX:-11.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.83,skewX:-9.5,y:258.5},0).wait(2).to({regX:0.1,scaleY:0.82,skewX:-7.1,x:375.1},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-4.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.81,skewX:-2.3,y:258.5},0).wait(2).to({regX:0,scaleY:0.81,skewX:0,x:375.2},0).wait(4).to({regY:0,y:191.4},0).wait(4));

	// Cow Hind Leg Back
	this.cow_hindlegback = new lib.CowHindLegBack();
	this.cow_hindlegback.parent = this;
	this.cow_hindlegback.setTransform(503.2,179.4,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.cow_hindlegback).wait(76).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.5,x:502.2},0).wait(2).to({skewX:-0.8,x:501.9},0).wait(10).to({skewX:-0.5,x:502.3},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:0,x:503.2},0).wait(130).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.5,x:502.2},0).wait(2).to({skewX:-0.8,x:501.9},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:499.5},0).wait(2).to({scaleY:0.81,skewX:-4,x:497.1,y:179.5},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:494.6},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:492.2,y:179.4},0).wait(24).to({scaleY:0.82,skewX:-6.1,x:494},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:495.9,y:179.5},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:497.7},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:499.5,y:179.4},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:501.3},0).wait(2).to({scaleY:0.81,skewX:0,x:503.2},0).wait(56).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.5,x:502.2},0).wait(2).to({skewX:-0.8,x:501.9},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:499.5},0).wait(2).to({scaleY:0.81,skewX:-4,x:497.1,y:179.5},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:494.6},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:492.2,y:179.4},0).wait(19).to({scaleY:0.82,skewX:-6.1,x:494},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:495.9,y:179.5},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:497.7},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:499.5,y:179.4},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:501.3},0).wait(2).to({scaleY:0.81,skewX:0,x:503.2},0).wait(8));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(261.5,87.6,344,186.5);


(lib.cow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// neckGlow
	this.neckGlow = new lib.cow_neckGlow();
	this.neckGlow.parent = this;
	this.neckGlow.setTransform(168.6,123.7,1,1.072,0,0,0,25.7,32);
	this.neckGlow.alpha = 0;
	this.neckGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.neckGlow.cache(0,-4,56,73);

	this.timeline.addTween(cjs.Tween.get(this.neckGlow).wait(1));

	// tummyGlow
	this.tummyGlow = new lib.cow_tummyGlow();
	this.tummyGlow.parent = this;
	this.tummyGlow.setTransform(258.9,166,0.98,1.059,0,0,0,92.4,28.7);
	this.tummyGlow.alpha = 0;
	this.tummyGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.tummyGlow.cache(-1,10,149,54);

	this.timeline.addTween(cjs.Tween.get(this.tummyGlow).wait(1));

	// backGlow
	this.backGlow = new lib.cow_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(249.8,117.3,1.111,1,0,0,0,59,27.9);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(9,-4,115,55);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// legGlow
	this.legGlow = new lib.cow_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(326.5,170.9,1,1,0,0,0,25.2,78.8);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.legGlow.cache(-131,-5,187,169);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// Layer 21
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(351.1,156.5,2.687,0.282,86.5);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(268.9,175,1.955,1.268,177.3);

	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(178.2,124.8,1.578,0.596,109.6);

	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(164.5,88.9,0.857,0.525,130.5);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(102,131.5,0.935,0.828,88.3);

	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(199.8,204.4,2.211,1.413,90.3);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(328.4,173.1,3.785,0.866,86.5);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(262.6,115,2.082,1.352);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.back},{t:this.leg1},{t:this.leg2},{t:this.mouth},{t:this.ear},{t:this.neck},{t:this.tummy},{t:this.tail}]}).wait(1));

	// main
	this.main = new lib.Cow();
	this.main.parent = this;
	this.main.setTransform(-158.7,44.7,0.986,0.986,0,0,0,20.5,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.cow, new cjs.Rectangle(78.7,68.8,339,191.6), null);


// stage content:
(lib.MWcow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wrongAnswer":0,"rest":36,"wet":160,"clean":186,"excited":206,"animalSound":335});

	// timeline functions:
	this.frame_34 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_158 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_184 = function() {
		/* stop();*/
	}
	this.frame_204 = function() {
		/* stop();*/
	}
	this.frame_290 = function() {
		playSound("GleamAfterDrying5wav");
	}
	this.frame_332 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_397 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(34).call(this.frame_34).wait(124).call(this.frame_158).wait(26).call(this.frame_184).wait(20).call(this.frame_204).wait(86).call(this.frame_290).wait(42).call(this.frame_332).wait(65).call(this.frame_397).wait(2));

	// neck bubbles
	this.neck_bubbles_1 = new lib.CowNeck_bubbles();
	this.neck_bubbles_1.parent = this;
	this.neck_bubbles_1.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles_1).wait(36).to({_off:true},124).wait(239));

	// Cow Torso
	this.back_bubbles_1 = new lib.CowTorso_bubbles();
	this.back_bubbles_1.parent = this;
	this.back_bubbles_1.setTransform(444.3,155.1,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles_1).wait(36).to({_off:true},124).wait(239));

	// Cow Hind Leg
	this.legs_bubbles_1 = new lib.CowHindLeg_bubbles();
	this.legs_bubbles_1.parent = this;
	this.legs_bubbles_1.setTransform(516.9,179.2,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles_1).wait(36).to({_off:true},124).wait(239));

	// sparkle
	this.instance_12 = new lib.sparkle();
	this.instance_12.parent = this;
	this.instance_12.setTransform(394.9,147.5,0.461,0.461);
	this.instance_12._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(326).to({_off:false},0).to({_off:true},9).wait(64));

	// sparkle
	this.instance_13 = new lib.sparkle();
	this.instance_13.parent = this;
	this.instance_13.setTransform(334.2,126.1,0.679,0.679);
	this.instance_13._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(314).to({_off:false},0).to({_off:true},21).wait(64));

	// sparkle
	this.instance_14 = new lib.sparkle();
	this.instance_14.parent = this;
	this.instance_14.setTransform(528.7,171.4,0.679,0.679);
	this.instance_14._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(300).to({_off:false},0).to({_off:true},35).wait(64));

	// sparkle
	this.instance_15 = new lib.sparkle();
	this.instance_15.parent = this;
	this.instance_15.setTransform(453.6,138.9,0.679,0.679);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(290).to({_off:false},0).to({_off:true},45).wait(64));

	// Cow Head_001
	this.instance_16 = new lib.CowHead_001_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(327.2,128.5,0.923,0.923,0,0,180);

	this.instance_17 = new lib.CowHead_003_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(345.5,128.5,0.995,0.995,0,0,180,-17.3,0);
	this.instance_17._off = true;

	this.instance_18 = new lib.CowHead_005_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(345.5,128.5,1.04,1.04,0,0,180,-17.3,0);

	this.instance_19 = new lib.CowHead_006_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(345.6,128.5,1.063,1.063,0,0,180,-17.3,0);
	this.instance_19._off = true;

	this.instance_20 = new lib.CowHead_moo_001_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(295,122.2,0.923,0.923,0,11.7,-168.3);
	this.instance_20._off = true;

	this.instance_21 = new lib.CowHead_moo_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(305.5,104.1,0.923,0.923,0,40.4,-139.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_16}]}).to({state:[{t:this.instance_17}]},4).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_18}]},18).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_16}]},10).to({state:[{t:this.instance_17}]},9).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_19}]},27).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},8).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_18}]},40).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_16}]},20).to({state:[{t:this.instance_16}]},26).to({state:[{t:this.instance_16}]},20).to({state:[{t:this.instance_16}]},18).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},6).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_21}]},2).to({state:[{t:this.instance_20}]},18).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_17}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_19}]},51).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},6).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_21}]},2).to({state:[{t:this.instance_20}]},13).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_17}]},2).to({state:[{t:this.instance_19}]},2).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({_off:true},4).wait(22).to({_off:false},0).wait(10).to({_off:true},9).wait(95).to({_off:false},0).wait(88).to({skewX:-3.6,skewY:176.4,y:128.1},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.3,skewY:172.7,x:327.3,y:127.8},0).wait(2).to({skewX:-11.1,skewY:168.9,y:127.4},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-14.9,skewY:165.1,y:127},0).wait(6).to({skewX:-36.9,skewY:143.1,x:328.3,y:137.6},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-53.4,skewY:126.6,x:330.4,y:143.7},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-70,skewY:110,x:332.6,y:149.9},0).wait(2).to({skewX:-59.8,skewY:120.2,x:315.1,y:155.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24,skewY:156,x:305,y:138.8},0).to({_off:true},2).wait(24).to({_off:false,scaleX:0.92,scaleY:0.92,skewX:-27.7,skewY:152.3,x:303.4,y:138},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24.3,skewY:155.7,x:310.7,y:137.3},0).wait(2).to({skewX:-20.8,skewY:159.2,x:318,y:136.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-17.4,skewY:162.6,x:325.3,y:135.8},0).to({_off:true},2).wait(54).to({_off:false,skewX:0,skewY:180,x:327.2,y:128.5},0).wait(4).to({skewX:-3.6,skewY:176.4,y:128.1},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.3,skewY:172.7,x:327.3,y:127.8},0).wait(2).to({skewX:-11.1,skewY:168.9,y:127.4},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-14.9,skewY:165.1,y:127},0).wait(6).to({skewX:-36.9,skewY:143.1,x:328.3,y:137.6},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-53.4,skewY:126.6,x:330.4,y:143.7},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-70,skewY:110,x:332.6,y:149.9},0).wait(2).to({skewX:-59.8,skewY:120.2,x:315.1,y:155.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24,skewY:156,x:305,y:138.8},0).to({_off:true},2).wait(19).to({_off:false,scaleX:0.92,scaleY:0.92,skewX:-27.7,skewY:152.3,x:303.4,y:138},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-24.3,skewY:155.7,x:310.7,y:137.3},0).wait(2).to({skewX:-20.8,skewY:159.2,x:318,y:136.5},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-17.4,skewY:162.6,x:325.3,y:135.8},0).to({_off:true},2).wait(10));
	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(4).to({_off:false},0).to({_off:true},1).wait(20).to({_off:false},0).to({_off:true},1).wait(19).to({_off:false},0).to({_off:true},1).wait(93).to({_off:false},0).to({_off:true},1).wait(142).to({_off:false,regY:0.2,skewX:-9.9,skewY:170.1,x:343.5,y:127.6},0).to({_off:true},2).wait(105).to({_off:false},0).to({_off:true},2).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(6).to({_off:false},0).to({_off:true},18).wait(23).to({_off:false},0).wait(29).to({regY:0.3,skewX:0.3,skewY:180.3,x:345.3,y:128.1},0).wait(2).to({regY:0,skewX:0.5,skewY:180.5,x:345,y:126.9},0).wait(2).to({regY:0.2,skewX:0.8,skewY:180.8,x:344.7,y:126.3},0).wait(2).to({regY:0.1,skewX:1,skewY:181,x:344.3,y:125.3},0).wait(10).to({regX:-17.4,regY:2.9,skewX:0.8,skewY:180.8,x:344.7,y:129.1},0).wait(2).to({regX:-17.3,regY:0.1,skewX:0.5,skewY:180.5,x:345,y:126.9},0).wait(2).to({regX:-17.2,skewX:0.3,skewY:180.3,x:345.2,y:127.8},0).wait(2).to({regX:-17.3,regY:0,skewX:0,skewY:180,x:345.6,y:128.5},0).to({_off:true},40).wait(146).to({_off:false},0).wait(51).to({_off:true},1).wait(55).to({_off:false},0).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(250).to({_off:false},0).to({_off:true},2).wait(18).to({_off:false,x:294,y:128.8},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.8,skewY:-187.8,x:298.8,y:133.4},0).to({_off:true},2).wait(88).to({_off:false,scaleX:0.92,scaleY:0.92,skewX:11.7,skewY:-168.3,x:295,y:122.2},0).to({_off:true},2).wait(13).to({_off:false,x:294,y:128.8},0).wait(2).to({scaleX:0.92,scaleY:0.92,skewX:-7.8,skewY:-187.8,x:298.8,y:133.4},0).to({_off:true},2).wait(18));

	// Cow Neck
	this.cow_neck_4 = new lib.CowNeck();
	this.cow_neck_4.parent = this;
	this.cow_neck_4.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);

	this.instance_22 = new lib.CowFrontLeg_001();
	this.instance_22.parent = this;
	this.instance_22.setTransform(402.2,185.1,0.81,0.81,0,0,180);
	this.instance_22._off = true;

	this.instance_23 = new lib.CowFrontLeg_002();
	this.instance_23.parent = this;
	this.instance_23.setTransform(401.9,184.8,0.81,0.81,0,0,180);

	this.instance_24 = new lib.CowFrontLeg_003();
	this.instance_24.parent = this;
	this.instance_24.setTransform(401.6,184.5,0.81,0.81,0,0,180);

	this.instance_25 = new lib.CowFrontLeg_004();
	this.instance_25.parent = this;
	this.instance_25.setTransform(401.3,184.2,0.81,0.81,0,0,180);

	this.instance_26 = new lib.CowFrontLeg_005();
	this.instance_26.parent = this;
	this.instance_26.setTransform(401,183.9,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cow_neck_4}]}).to({state:[{t:this.cow_neck_4}]},4).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},18).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},10).to({state:[{t:this.cow_neck_4}]},8).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},27).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},8).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},40).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},1).to({state:[{t:this.cow_neck_4}]},20).to({state:[{t:this.cow_neck_4}]},26).to({state:[{t:this.cow_neck_4}]},20).to({state:[{t:this.instance_22}]},18).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_23,p:{regX:0,regY:0,skewX:0,x:401.9,y:184.8}}]},2).to({state:[{t:this.instance_24,p:{regX:0,regY:0,skewX:0,x:401.6,y:184.5}}]},2).to({state:[{t:this.instance_25,p:{regX:0,regY:0,skewX:0,x:401.3,y:184.2}}]},2).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_26}]},4).to({state:[{t:this.instance_25,p:{regX:5.2,regY:86.4,skewX:-2.1,x:401.1,y:254.2}}]},2).to({state:[{t:this.instance_24,p:{regX:-5.2,regY:91.4,skewX:-1.6,x:406.8,y:258.5}}]},2).to({state:[{t:this.instance_23,p:{regX:0.1,regY:95,skewX:-2.1,x:401.7,y:261.7}}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},22).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.cow_neck_4}]},2).to({state:[{t:this.cow_neck_4}]},47).to({state:[{t:this.instance_22}]},1).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_23,p:{regX:0,regY:0,skewX:0,x:401.9,y:184.8}}]},2).to({state:[{t:this.instance_24,p:{regX:0,regY:0,skewX:0,x:401.6,y:184.5}}]},2).to({state:[{t:this.instance_25,p:{regX:0,regY:0,skewX:0,x:401.3,y:184.2}}]},2).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_26}]},4).to({state:[{t:this.instance_25,p:{regX:5.2,regY:86.4,skewX:-2.1,x:401.1,y:254.2}}]},2).to({state:[{t:this.instance_24,p:{regX:-5.3,regY:91.4,skewX:-1.6,x:406.9,y:258.5}}]},2).to({state:[{t:this.instance_23,p:{regX:0.1,regY:95,skewX:-2.1,x:401.7,y:261.7}}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},17).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.cow_neck_4}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_neck_4).wait(4).to({regX:-16.7,regY:9.7,scaleX:0.91,scaleY:0.81,skewX:-3.8,x:371.1,y:142.5},0).wait(1).to({regX:-16.6,regY:9.6,scaleX:0.86,scaleY:0.81,skewX:-1.8,x:371,y:142.4},0).wait(1).to({scaleX:0.81,scaleY:0.81,skewX:0},0).wait(18).to({scaleX:0.86,scaleY:0.81,skewX:-1.8},0).wait(1).to({regX:-16.7,regY:9.7,scaleX:0.91,scaleY:0.81,skewX:-3.8,x:371.1,y:142.5},0).wait(1).to({regX:-16.6,regY:9.6,scaleX:0.96,scaleY:0.81,skewX:-5.8,x:371,y:142.4},0).wait(19).to({regX:-16.7,regY:9.7,scaleX:0.91,scaleY:0.81,skewX:-3.8,x:371.1,y:142.5},0).wait(1).to({regX:-16.6,regY:9.6,scaleX:0.86,scaleY:0.81,skewX:-1.8,x:371,y:142.4},0).wait(1).to({scaleX:0.81,scaleY:0.81,skewX:0},0).wait(29).to({regY:6.2,x:370.5,y:139.2},0).wait(2).to({regX:-16.7,regY:9.6,skewX:0.3,skewY:180.3,x:370,y:141.4},0).wait(2).to({regX:-16.6,skewX:0.5,skewY:180.5,x:369.5,y:140.9},0).wait(2).to({regX:-16.7,skewX:0.8,skewY:180.8,x:369,y:140.5},0).wait(10).to({regX:-16.6,skewX:0.5,skewY:180.5,x:369.5,y:140.9},0).wait(2).to({regX:-16.7,skewX:0.3,skewY:180.3,x:370,y:141.4},0).wait(2).to({regX:-16.6,regY:6.2,skewX:0,skewY:180,x:370.5,y:139.2},0).wait(2).to({regY:9.6,x:371,y:142.4},0).wait(40).to({scaleX:0.86,scaleY:0.81,skewX:-1.8},0).wait(1).to({scaleX:0.91,scaleY:0.81,skewX:-3.8,y:142.5},0).wait(1).to({scaleX:0.96,scaleY:0.81,skewX:-5.8,y:142.4},0).wait(66).to({_off:true},18).wait(64).to({_off:false,scaleX:0.81,scaleY:0.81,skewX:0},0).wait(47).to({_off:true},1).wait(59).to({_off:false},0).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.instance_22).wait(224).to({_off:false},0).wait(2).to({_off:true},2).wait(18).to({_off:false,regY:98.8,scaleY:0.81,skewX:-3.5,y:265.1},0).wait(2).to({scaleY:0.82,skewX:-7},0).wait(2).to({scaleY:0.82,skewX:-9.3},0).wait(24).to({regX:-0.1,regY:98.6,scaleY:0.82,skewX:-7.6,y:265},0).wait(2).to({regY:98.7,scaleY:0.82,skewX:-6,x:402.3},0).wait(2).to({regX:0,regY:98.8,scaleY:0.82,skewX:-4.5,x:402.2,y:265.1},0).wait(2).to({regX:-0.1,regY:98.7,scaleY:0.81,skewX:-3,x:402.3},0).wait(2).to({regY:98.8,scaleY:0.81,skewX:-1.3},0).wait(2).to({regX:0,scaleY:0.81,skewX:0.1,x:402.2},0).wait(2).to({regY:0,skewX:0,y:185.1},0).to({_off:true},2).wait(48).to({_off:false},0).wait(2).to({_off:true},2).wait(18).to({_off:false,regY:98.8,scaleY:0.81,skewX:-3.5,y:265.1},0).wait(2).to({scaleY:0.82,skewX:-7},0).wait(2).to({scaleY:0.82,skewX:-9.3},0).wait(19).to({regX:-0.1,regY:98.6,scaleY:0.82,skewX:-7.6,y:265},0).wait(2).to({regY:98.7,scaleY:0.82,skewX:-6,x:402.3},0).wait(2).to({regX:0,regY:98.8,scaleY:0.82,skewX:-4.5,x:402.2,y:265.1},0).wait(2).to({regX:-0.1,regY:98.7,scaleY:0.81,skewX:-3,x:402.3},0).wait(2).to({regY:98.8,scaleY:0.81,skewX:-1.3},0).wait(2).to({regX:0,scaleY:0.81,skewX:0.1,x:402.2},0).wait(2).to({regY:0,skewX:0,y:185.1},0).to({_off:true},2).wait(4));

	// Cow Hind Leg
	this.cow_hindleg_4 = new lib.CowHindLeg();
	this.cow_hindleg_4.parent = this;
	this.cow_hindleg_4.setTransform(516.9,179.2,0.81,0.81,0,0,180);

	this.cow_neck_5 = new lib.CowNeck();
	this.cow_neck_5.parent = this;
	this.cow_neck_5.setTransform(371,142.4,0.963,0.814,0,-5.8,180,-16.6,9.6);
	this.cow_neck_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.cow_hindleg_4).wait(76).to({skewX:-0.1,x:516.6},0).wait(2).to({skewX:-0.3,x:516.3},0).wait(2).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.8,x:515.7},0).wait(10).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.3,x:516.4},0).wait(2).to({skewX:-0.1,x:516.7},0).wait(2).to({skewX:0,x:516.9},0).wait(108).to({_off:true},18).wait(64).to({_off:false},0).wait(47).to({_off:true},1).wait(59).to({_off:false},0).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_neck_5).wait(224).to({_off:false},0).wait(4).to({scaleX:0.94,scaleY:0.81,skewX:-4.8,skewY:179.7,x:370.4,y:142.2},0).wait(2).to({regX:-16.7,scaleX:0.91,scaleY:0.81,skewX:-3.6,skewY:179.2,x:369.7,y:142},0).wait(2).to({regX:-17,scaleX:0.89,scaleY:0.81,skewX:-2.6,skewY:178.7,x:369.4,y:141.6},0).wait(2).to({regX:-16.9,scaleX:0.87,scaleY:0.81,skewX:-1.7,skewY:178.3,x:368.4,y:141.4},0).wait(6).to({regY:9.5,skewX:-8.2,skewY:171.8},0).wait(2).to({regX:-17.1,scaleX:0.89,scaleY:0.81,skewX:-17,skewY:165.7,x:368.1,y:144.5},0).wait(2).to({regX:-17,regY:9.2,scaleX:0.92,scaleY:0.81,skewX:-26,skewY:159.5,x:367.4,y:147.5},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.22,scaleY:0.84,skewX:-28.8,skewY:161.5,x:362.5,y:146.4},0).wait(2).to({scaleX:1.24,scaleY:0.83,skewX:-13.3,skewY:175.7,x:355.3,y:144.9},0).wait(2).to({regX:-17.1,regY:9.3,scaleX:1.26,scaleY:0.83,skewX:1.8,skewY:189.7,x:348,y:143.5},0).wait(2).to({regX:-17.2,scaleX:1.31,scaleY:0.83,skewX:4.6,skewY:202.5,x:348.6,y:143.8},0).wait(18).to({regX:-17,regY:9.7,scaleX:1.26,scaleY:0.76,skewX:-7.4,skewY:180.5,x:349.3,y:143.2},0).wait(2).to({regY:9.8,scaleX:1.14,scaleY:0.8,skewX:-9,skewY:178.5,x:351.2,y:144.9},0).wait(2).to({regX:-16.9,scaleX:1.02,scaleY:0.85,skewX:-10.7,skewY:176.1,x:353.1,y:146.1},0).wait(2).to({regX:-16.7,regY:10,scaleX:1.02,scaleY:0.82,skewX:-10.6,skewY:174,x:357.8,y:144.7},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.01,scaleY:0.79,skewY:171.7,x:362.9,y:143},0).wait(2).to({regY:9.8,scaleX:1.01,scaleY:0.76,skewX:-10.7,skewY:169.3,x:367.9,y:141.4},0).wait(2).to({regX:-16.8,scaleX:0.91,scaleY:0.79,skewX:-5.3,skewY:174.7,x:369.3,y:142},0).wait(2).to({regX:-16.6,regY:9.6,scaleX:0.81,scaleY:0.81,skewX:0,skewY:180,x:371,y:142.4},0).to({_off:true},4).wait(48).to({_off:false,scaleX:0.96,scaleY:0.81,skewX:-5.8},0).wait(4).to({scaleX:0.94,scaleY:0.81,skewX:-4.8,skewY:179.7,x:370.4,y:142.2},0).wait(2).to({regX:-16.7,scaleX:0.91,scaleY:0.81,skewX:-3.6,skewY:179.2,x:369.7,y:142},0).wait(2).to({regX:-17,scaleX:0.89,scaleY:0.81,skewX:-2.6,skewY:178.7,x:369.4,y:141.6},0).wait(2).to({regX:-16.9,scaleX:0.87,scaleY:0.81,skewX:-1.7,skewY:178.3,x:368.4,y:141.4},0).wait(6).to({regY:9.5,skewX:-8.2,skewY:171.8},0).wait(2).to({regX:-17.1,scaleX:0.89,scaleY:0.81,skewX:-17,skewY:165.7,x:368.1,y:144.5},0).wait(2).to({regX:-17,regY:9.2,scaleX:0.92,scaleY:0.81,skewX:-26,skewY:159.5,x:367.4,y:147.5},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.22,scaleY:0.84,skewX:-28.8,skewY:161.5,x:362.5,y:146.4},0).wait(2).to({scaleX:1.24,scaleY:0.83,skewX:-13.3,skewY:175.7,x:355.3,y:144.9},0).wait(2).to({regX:-17.1,regY:9.3,scaleX:1.26,scaleY:0.83,skewX:1.8,skewY:189.7,x:348,y:143.5},0).wait(2).to({regX:-17.2,scaleX:1.31,scaleY:0.83,skewX:4.6,skewY:202.5,x:348.6,y:143.8},0).wait(13).to({regX:-17,regY:9.7,scaleX:1.26,scaleY:0.76,skewX:-7.4,skewY:180.5,x:349.3,y:143.2},0).wait(2).to({regY:9.8,scaleX:1.14,scaleY:0.8,skewX:-9,skewY:178.5,x:351.2,y:144.9},0).wait(2).to({regX:-16.9,scaleX:1.02,scaleY:0.85,skewX:-10.7,skewY:176.1,x:353.1,y:146.1},0).wait(2).to({regX:-16.7,regY:10,scaleX:1.02,scaleY:0.82,skewX:-10.6,skewY:174,x:357.8,y:144.7},0).wait(2).to({regX:-16.9,regY:9.9,scaleX:1.01,scaleY:0.79,skewY:171.7,x:362.9,y:143},0).wait(2).to({regY:9.8,scaleX:1.01,scaleY:0.76,skewX:-10.7,skewY:169.3,x:367.9,y:141.4},0).wait(2).to({regX:-16.8,scaleX:0.91,scaleY:0.79,skewX:-5.3,skewY:174.7,x:369.3,y:142},0).wait(2).to({regX:-16.6,regY:9.6,scaleX:0.81,scaleY:0.81,skewX:0,skewY:180,x:371,y:142.4},0).to({_off:true},4).wait(4));

	// Cow Front Leg
	this.cow_frontleg_11 = new lib.CowFrontLeg();
	this.cow_frontleg_11.parent = this;
	this.cow_frontleg_11.setTransform(402.2,185.1,0.81,0.81,0,0,180);

	this.cow_frontleg_12 = new lib.CowFrontLeg_002();
	this.cow_frontleg_12.parent = this;
	this.cow_frontleg_12.setTransform(401.9,184.8,0.81,0.81,0,0,180);

	this.cow_frontleg_13 = new lib.CowFrontLeg_003();
	this.cow_frontleg_13.parent = this;
	this.cow_frontleg_13.setTransform(401.6,184.5,0.81,0.81,0,0,180);

	this.cow_frontleg_14 = new lib.CowFrontLeg_004();
	this.cow_frontleg_14.parent = this;
	this.cow_frontleg_14.setTransform(401.3,184.2,0.81,0.81,0,0,180);

	this.cow_frontleg_15 = new lib.CowFrontLeg_005();
	this.cow_frontleg_15.parent = this;
	this.cow_frontleg_15.setTransform(401,183.9,0.81,0.81,0,0,180);

	this.cow_frontleg_16 = new lib.CowFrontLeg_001();
	this.cow_frontleg_16.parent = this;
	this.cow_frontleg_16.setTransform(402.2,185.1,0.81,0.81,0,0,180);
	this.cow_frontleg_16._off = true;

	this.cow_hindleg_5 = new lib.CowHindLeg();
	this.cow_hindleg_5.parent = this;
	this.cow_hindleg_5.setTransform(516.9,179.2,0.81,0.81,0,0,180);
	this.cow_hindleg_5._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cow_frontleg_11}]}).to({state:[{t:this.cow_frontleg_11}]},36).to({state:[{t:this.cow_frontleg_11}]},38).to({state:[{t:this.cow_frontleg_12}]},2).to({state:[{t:this.cow_frontleg_13}]},2).to({state:[{t:this.cow_frontleg_14}]},2).to({state:[{t:this.cow_frontleg_15}]},2).to({state:[{t:this.cow_frontleg_15}]},8).to({state:[{t:this.cow_frontleg_14}]},2).to({state:[{t:this.cow_frontleg_13}]},2).to({state:[{t:this.cow_frontleg_12}]},2).to({state:[{t:this.cow_frontleg_11}]},2).to({state:[{t:this.cow_frontleg_16}]},62).to({state:[{t:this.cow_frontleg_16}]},26).to({state:[{t:this.cow_frontleg_16}]},20).to({state:[{t:this.cow_hindleg_5}]},18).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},8).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},22).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_frontleg_16}]},2).to({state:[{t:this.cow_frontleg_16}]},47).to({state:[{t:this.cow_hindleg_5}]},1).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},8).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},17).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_hindleg_5}]},2).to({state:[{t:this.cow_frontleg_16}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_frontleg_11).wait(74).to({_off:true},2).wait(22).to({_off:false},0).to({_off:true},62).wait(239));
	this.timeline.addTween(cjs.Tween.get(this.cow_frontleg_16).wait(160).to({_off:false},0).wait(46).to({_off:true},18).wait(64).to({_off:false},0).wait(47).to({_off:true},1).wait(59).to({_off:false},0).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.cow_hindleg_5).wait(224).to({_off:false},0).wait(4).to({skewX:-0.1,x:516.6},0).wait(2).to({skewX:-0.3,x:516.3},0).wait(2).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.8,x:515.7},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:513.2},0).wait(2).to({scaleY:0.81,skewX:-4,x:510.8},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:508.4},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:505.9},0).wait(24).to({scaleY:0.82,skewX:-6.1,x:507.8,y:179.1},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:509.6,y:179.2},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:511.5},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:513.3},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:515.1},0).wait(2).to({scaleY:0.81,skewX:0,x:516.9},0).wait(2).to({_off:true},2).wait(48).to({_off:false},0).wait(4).to({skewX:-0.1,x:516.6},0).wait(2).to({skewX:-0.3,x:516.3},0).wait(2).to({skewX:-0.5,x:516},0).wait(2).to({skewX:-0.8,x:515.7},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:513.2},0).wait(2).to({scaleY:0.81,skewX:-4,x:510.8},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:508.4},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:505.9},0).wait(19).to({scaleY:0.82,skewX:-6.1,x:507.8,y:179.1},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:509.6,y:179.2},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:511.5},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:513.3},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:515.1},0).wait(2).to({scaleY:0.81,skewX:0,x:516.9},0).wait(2).to({_off:true},2).wait(4));

	// Cow Torso
	this.cow_torso_1 = new lib.CowTorso();
	this.cow_torso_1.parent = this;
	this.cow_torso_1.setTransform(444.3,155.1,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.cow_torso_1).wait(76).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:1,skewY:181,x:442.4,y:153.7},0).wait(10).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0,skewY:180,x:444.3,y:155.1},0).wait(130).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:1,skewY:181,x:442.4,y:153.7},0).wait(10).to({skewX:0.8,skewY:180.8,x:437.2,y:154.2},0).wait(2).to({skewX:0.5,skewY:180.5,x:432.1,y:154.7},0).wait(2).to({skewX:0.3,skewY:180.3,x:426.9,y:155.2},0).wait(2).to({skewX:0,skewY:180,x:421.7,y:155.7},0).wait(24).to({x:425.4,y:155.6},0).wait(2).to({x:429.2,y:155.5},0).wait(2).to({x:433,y:155.4},0).wait(2).to({x:436.7,y:155.3},0).wait(2).to({x:440.5,y:155.2},0).wait(2).to({x:444.3,y:155.1},0).wait(56).to({skewX:0.3,skewY:180.3,x:443.8,y:154.7},0).wait(2).to({skewX:0.5,skewY:180.5,x:443.4,y:154.4},0).wait(2).to({skewX:0.8,skewY:180.8,x:442.9,y:154},0).wait(2).to({skewX:1,skewY:181,x:442.4,y:153.7},0).wait(10).to({skewX:0.8,skewY:180.8,x:437.2,y:154.2},0).wait(2).to({skewX:0.5,skewY:180.5,x:432.1,y:154.7},0).wait(2).to({skewX:0.3,skewY:180.3,x:426.9,y:155.2},0).wait(2).to({skewX:0,skewY:180,x:421.7,y:155.7},0).wait(19).to({x:425.4,y:155.6},0).wait(2).to({x:429.2,y:155.5},0).wait(2).to({x:433,y:155.4},0).wait(2).to({x:436.7,y:155.3},0).wait(2).to({x:440.5,y:155.2},0).wait(2).to({x:444.3,y:155.1},0).wait(8));

	// Cow Tail
	this.instance_27 = new lib.CowTail();
	this.instance_27.parent = this;
	this.instance_27.setTransform(534.3,173.4,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_27).wait(76).to({x:535.3,y:172.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.3,y:172.1},0).wait(2).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:538.2,y:170.8},0).wait(10).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.2,y:172.1},0).wait(2).to({skewX:0,skewY:180,x:535.3,y:172.8},0).wait(2).to({x:534.3,y:173.4},0).wait(130).to({x:535.3,y:172.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.3,y:172.1},0).wait(2).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:538.2,y:170.8},0).wait(10).to({skewX:-0.3,skewY:179.7,x:535,y:171.5},0).wait(2).to({skewX:-0.1,skewY:179.9,x:531.7,y:172.1},0).wait(2).to({skewX:0,skewY:180,x:528.5,y:172.8},0).wait(2).to({x:525.3,y:173.4},0).wait(24).to({x:526.8},0).wait(2).to({x:528.3},0).wait(2).to({x:529.8},0).wait(2).to({x:531.3},0).wait(2).to({x:532.8},0).wait(2).to({x:534.3},0).wait(56).to({x:535.3,y:172.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:536.3,y:172.1},0).wait(2).to({skewX:-0.3,skewY:179.7,x:537.2,y:171.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:538.2,y:170.8},0).wait(10).to({skewX:-0.3,skewY:179.7,x:535,y:171.5},0).wait(2).to({skewX:-0.1,skewY:179.9,x:531.7,y:172.1},0).wait(2).to({skewX:0,skewY:180,x:528.5,y:172.8},0).wait(2).to({x:525.3,y:173.4},0).wait(19).to({x:526.8},0).wait(2).to({x:528.3},0).wait(2).to({x:529.8},0).wait(2).to({x:531.3},0).wait(2).to({x:532.8},0).wait(2).to({x:534.3},0).wait(8));

	// Cow Front Leg Back
	this.cow_frontlegback_1 = new lib.CowFrontLegBack();
	this.cow_frontlegback_1.parent = this;
	this.cow_frontlegback_1.setTransform(375.2,191.4,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.cow_frontlegback_1).wait(242).to({regY:82.8,y:258.5},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-3.5,x:375.3},0).wait(2).to({scaleY:0.82,skewX:-7.1},0).wait(2).to({scaleY:0.83,skewX:-10.8,y:258.4},0).wait(2).to({regX:0,scaleY:0.84,skewX:-14.4,x:375.2,y:258.5},0).wait(24).to({regX:-0.1,scaleY:0.83,skewX:-11.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.83,skewX:-9.5,y:258.5},0).wait(2).to({regX:0.1,scaleY:0.82,skewX:-7.1,x:375.1},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-4.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.81,skewX:-2.3,y:258.5},0).wait(2).to({regX:0,scaleY:0.81,skewX:0,x:375.2},0).wait(4).to({regY:0,y:191.4},0).wait(66).to({regY:82.8,y:258.5},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-3.5,x:375.3},0).wait(2).to({scaleY:0.82,skewX:-7.1},0).wait(2).to({scaleY:0.83,skewX:-10.8,y:258.4},0).wait(2).to({regX:0,scaleY:0.84,skewX:-14.4,x:375.2,y:258.5},0).wait(19).to({regX:-0.1,scaleY:0.83,skewX:-11.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.83,skewX:-9.5,y:258.5},0).wait(2).to({regX:0.1,scaleY:0.82,skewX:-7.1,x:375.1},0).wait(2).to({regX:-0.1,scaleY:0.82,skewX:-4.8,x:375.3,y:258.4},0).wait(2).to({scaleY:0.81,skewX:-2.3,y:258.5},0).wait(2).to({regX:0,scaleY:0.81,skewX:0,x:375.2},0).wait(4).to({regY:0,y:191.4},0).wait(4));

	// Cow Hind Leg Back
	this.cow_hindlegback_1 = new lib.CowHindLegBack();
	this.cow_hindlegback_1.parent = this;
	this.cow_hindlegback_1.setTransform(503.2,179.4,0.81,0.81,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.cow_hindlegback_1).wait(76).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.5,x:502.2},0).wait(2).to({skewX:-0.8,x:501.9},0).wait(10).to({skewX:-0.5,x:502.3},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:0,x:503.2},0).wait(130).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.5,x:502.2},0).wait(2).to({skewX:-0.8,x:501.9},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:499.5},0).wait(2).to({scaleY:0.81,skewX:-4,x:497.1,y:179.5},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:494.6},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:492.2,y:179.4},0).wait(24).to({scaleY:0.82,skewX:-6.1,x:494},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:495.9,y:179.5},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:497.7},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:499.5,y:179.4},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:501.3},0).wait(2).to({scaleY:0.81,skewX:0,x:503.2},0).wait(56).to({skewX:-0.1,x:502.9},0).wait(2).to({skewX:-0.3,x:502.6},0).wait(2).to({skewX:-0.5,x:502.2},0).wait(2).to({skewX:-0.8,x:501.9},0).wait(10).to({scaleY:0.81,skewX:-2.3,x:499.5},0).wait(2).to({scaleY:0.81,skewX:-4,x:497.1,y:179.5},0).wait(2).to({scaleY:0.82,skewX:-5.8,x:494.6},0).wait(2).to({scaleY:0.82,skewX:-7.5,x:492.2,y:179.4},0).wait(19).to({scaleY:0.82,skewX:-6.1,x:494},0).wait(2).to({scaleY:0.81,skewX:-4.8,x:495.9,y:179.5},0).wait(2).to({scaleY:0.81,skewX:-3.6,x:497.7},0).wait(2).to({scaleY:0.81,skewX:-2.3,x:499.5,y:179.4},0).wait(2).to({scaleY:0.81,skewX:-1.1,x:501.3},0).wait(2).to({scaleY:0.81,skewX:0,x:503.2},0).wait(8));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(561.5,241.1,344,186.5);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWcow_atlas_.png?1529087720753", id:"MWcow_atlas_"},
		{src:"sounds/GleamAfterDrying5wav.mp3?1529087721183", id:"GleamAfterDrying5wav"}
	],
	preloads: []
};




})(lib_Cow = lib_Cow||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Cow, images, createjs, ss, AdobeAn;